import {
  OfferStatus,
  ExclusiveStatus,
  OperType,
  ItemType,
  Locale,
  UIPriceCurrency,
} from 'common/types';
import {PremiumType} from '../../../common/types';

export default {
  login_screen: {
    info: {
      title: 'Вітаємо вас у спільноті найкращих рієлторів України! ',
      subtitle: 'Дякуємо, що ви з RIELTOR.UA. Бажаємо вам більше укладених угод!'
    },
    html_title: 'Вхід',
    form: {
      title: 'Вхід',
      submit: 'Готово',
      reset_password_legacy_ui: 'забув пароль',
    },
    footer: {
      contact_us: "Зв'язатися з нами",
    },
    notification: {
      success: 'Ви успішно авторизувались',
    },
    registration: 'Зареєструватися',
    register: 'реєстрація',
    restore_user: 'Відновити профіль',
    login: 'вхід',
  },
  registration_screen: {
    info:{
      title: 'Приєднайтесь до спільноти найкращих рієлторів України! ',
      text: 'Реєструйтесь, верифікуйтесь та розміщуйте своє перше безкоштовне оголошення.',
      perevagu:{
        title: 'Що ви отримуєте',
        hide_perevagu: 'Cховати',
        per_avatar: 'понад 3 млн відвідувачів на місяць',
        per_coins: 'поденну оплату за оголошення\u00A0— ніяких переплат',
        per_flatfy: 'найшвидшу публікацію на Flatfy та ЛУН',
        per_mobile: 'зручну мобільну версію — розміщуйте оголошення прямо з телефона',
        per_viber: 'заявки від клієнтів прямо у Вайбер',
        per_stats: 'зрозумілу статистику: перегляди оголошень, дзвінки, витрати',
      }
    },
    call_back: ' Зв\'язатись з нами',
    html_title: 'Реєстрація',
    form: {
      title: 'Реєстрація',
      terms: {
        message: 'я погоджуюсь з {link} сайту',
        link: 'умовами',
      },
      submit: 'Готово',
      already_registered: 'Цей номер вже зареєстрований',
      login: 'Увійти',
    },
    notification: {
      code: {
        sent: 'Відправили SMS з кодом підтвердження',
      },
    },
  },
  registration_info_screen: {
    html_title: 'Реєстрація',
    form: {
      agency_form_remark: 'Лише для адміністраторів АН та організацій',
      avatar_rieltor_remark: 'Для реєстрації необхідно додати особисте фото',
      avatar_agency_remark: 'Для реєстрації необхідно додати логотип агентства',
      address_np_remark: 'Відділення НП для доставки майбутніх подарунків',
      step_n_from_m: 'Крок {current} з {total}',
      title: 'Реєстрація',
      user_type: {
        owner: 'Власник',
        realtor: 'Рієлтор',
        agency: 'Агентство',
      },
      fields: {
        facebook: 'Facebook',
        instagram: 'Instagram',
        youtube: 'Youtube',
        tiktok: 'Tik Tok',
        owner: {
          name: "Ім'я",
          email: 'Email',
          city: 'Місто',
          image: 'Фото',
          password: 'Пароль',
          inn: 'РНОКПП (ідентифікаційний податковий номер)',
        },
        realtor: {
          name: 'ПІБ',
          email: 'Email',
          city: 'Місто',
          image: 'Фото',
          site: 'Сайт',
          started_at: 'Працюю рієлтором з',
          about: 'Про себе',
          speak_english: 'Speak English',
          specialization: 'Спеціалізація',
          password: 'Пароль',
          address_np: 'Відділення НП'
        },
        agency: {
          name: 'Назва агентства',
          email: 'Email',
          city: 'Місто',
          street: 'Вулиця',
          house: 'Будинок',
          address: 'Уточнююча адреса',
          site: 'Сайт',
          started_at: 'Працюємо на ринку з',
          about: 'Опис',
          specialization: 'Спеціалізація',
          image: 'Логотип агентства',
          password: 'Пароль',
        },
      },
      submit: 'Готово',
      bankid_verificate_referral: 'Верифікуватись та отримати {bonus} грн.',
      bankid_verificate: 'Верифікуватись',
      nobankdid: 'Продовжити без верифікації',
      new_bonus_title: 'Отримайте {coins} грн на рахунок від Rieltor',
      new_bonus_description: 'Верифікуйте ваш профіль, щоб отримати {coins} грн для реклами ваших оголошень',
    },
    notification: {
      registration_success: 'Ви успішно зареєстувались',
      not_valid_form: 'Перевірте правильність уведених полів',
    },
    verification_text_bonus: 'ТІльки після верифікації ви зможете опублікувати оголошення, а також вам буде нараховано {coins} монет для реклами ваших об\'єктів.',
    verification_text_bonus_limit: 'Тільки після верифікації ви зможете опублікувати {count, plural, one {оголошення} few {# оголошення} other {# оголошень}} безкоштовно, а також вам буде нараховано {coins} монет для реклами ваших об\'єктів.'
  },
  restore_user_screen: {
    html_title: 'Відновлення профілю',
    form: {
      title: 'Відновлення профілю',
      submit: 'Готово',
      recover: 'Відновити',
    },
    notification: {
      code: {
        sent: 'Відправили SMS з кодом підтвердження',
      },
      reset_success: 'Профіль успішно відновлено',
    },
  },
  reset_password_screen: {
    html_title: 'Відновлення паролю1',
    form: {
      title: 'Відновлення паролю1',
      submit: 'Готово',
    },
    notification: {
      code: {
        sent: 'Відправили SMS з кодом підтвердження',
      },
      reset_success: 'Пароль успішно відновлено',
    },
    registration: 'Зареєструватися',
  },
  offer_details_screen: {
    html_title_create: 'Нове оголошення',
    title_create: 'Нове оголошення',
    html_title_edit: 'Редагування оголошення #{offerId}',
    title_edit: 'Редагування оголошення #{offerId}',
    step_title: {
      0: 'Тип нерухомості',
      1: 'Основні параметри',
      2: "Інформація про об'єкт",
      3: 'Додаткові параметри',
      4: "Адреса об'єкта",
      5: 'Фото, відео',
      6: 'Ексклюзивний договір з власником',
      7: 'Особисті нотатки',
    },
    navigation: {
      prev: 'Назад',
      next: 'Далі',
      publish: 'Опублікувати',
      save: 'Зберегти',
      save_draft: 'Зберегти чернетку',
    },
    form: {
      fields: {
        description: {
          label: 'Опис',
        },
        groupTitle_1_3: {
          label: 'Блок 1 з 5: Про будинок',
          subTitle:
            'Тут ви можете дати волю фантазії і описати об’єкт нерухомості якнайкраще! Якщо ви зняли відеотур - просто додайте посилання на відео з YouTube або TikTok (приймається відео лише про запропонований обʼєкт). Також завантажте якомога більше фотографій.',
        },
        groupTitle_2_3: {
          label: 'Блок 5 з 5: Інфраструктура',
          subTitle:
            'Що знаходиться поруч - школа, садочок, цілодобовий супермаркет? Опишіть навколишню інфраструктуру та додайте фотографії магазинів, скверів, кав’ярень, які знаходяться поблизу.',
        },
        groupTitle_3_3: {
          label: 'Блок 2 з 5: Деталі інтер’єру',
          subTitle:
            'Можливо, в будинку зроблений дизайнерський ремонт або фурнітура була виготовлена на замовлення? Опишіть усі важливі деталі, техніку, меблі, які є в будинку. Також додайте їх фотографії крупним планом.',
        },
        groupTitle_4_3: {
          label: 'Блок 4 з 5: Двір',
          subTitle:
            'Додайте фотографії подвір‘я - щоб покупець відразу міг його оцінити.',
        },
        groupTitle_5_3: {
          label: 'Блок 3 з 5: Планування',
          subTitle:
            'В цьому блоці ви можете завантажити планування будинку та описати усі його переваги.',
        },

        groupTitle_1_1: {
          label: 'Блок 1 з 5: Про квартиру',
          subTitle:
            'Тут ви можете дати волю фантазії і описати об’єкт нерухомості якнайкраще! Якщо ви зняли відеотур - просто додайте посилання на відео з YouTube або TikTok (приймається відео лише про запропонований обʼєкт). Також завантажте якомога більше фотографій.',
        },
        groupTitle_2_1: {
          label: 'Блок 5 з 5: Інфраструктура',
          subTitle:
            'Що знаходиться поруч - школа, садочок, цілодобовий супермаркет? Опишіть навколишню інфраструктуру та додайте фотографії магазинів, скверів, кав’ярень, які знаходяться поблизу.',
        },
        groupTitle_3_1: {
          label: 'Блок 2 з 5: Деталі інтер’єру',
          subTitle:
            'Можливо, в квартирі зроблений дизайнерський ремонт або фурнітура була виготовлена на замовлення? Опишіть усі важливі деталі, техніку, меблі, які є в квартирі. Також додайте їх фотографії крупним планом.',
        },
        groupTitle_4_1: {
          label: 'Блок 4 з 5: Будинок та двір',
          subTitle:
            'Розкажіть про будинок, у якому знаходиться квартира. Чи є, наприклад, просторий вестибюль або вантажний ліфт? Додайте фотографії двору, дитячого майданчика,  парковки - щоб покупець відразу міг їх оцінити.',
        },
        groupTitle_5_1: {
          label: 'Блок 3 з 5: Планування',
          subTitle:
            'В цьому блоці ви можете завантажити планування квартири та описати усі його переваги.',
        },
        commission: {
          label: 'Комісія з покупця/орендатора',
        },
        without_commission: {
          label: 'Без комісії',
        },
        price: {
          label: 'Ціна',
        },
        commission_rate: {
          label: 'Розмір комісії',
        },
        commission_type: {
          label: 'Комісія у'
        },
        pay_commission: {
          label: 'Ділюся комісією з колегами (інформація доступна тільки для рієлторів), %',
          label_owner: 'Ділюся комісією за залучення покупця/орендаря (інформація доступна тільки для рієлторів), %',
        },
        video_link: {
          label: 'Посилання на відеотур',
        },
        date: {
          label: 'Термін дії',
        },
        flat_number: {
          label: 'Номер квартири',
        },
        inn: {
          label: 'РНОКПП (ідентифікаційний податковий номер)',
        },
        exclusive_inn: {
          label: 'ІПН власника',
        },
        exclusive_reg_num: {
          label: 'Реєстраційний номер нерухомості ',
        },
        cadastral_number: {
          label: 'Кадастровий номер',
          placeholder: 'ХХХХХХХХХХ:ХХ:ХХХ:ХХХХ',
        },
        allow_children: {
          label: 'Можна з дітьми',
        },
        allow_pets: {
          label: 'Можна з тваринами',
        },
        allow_assignment: {
          label: 'Переуступка',
        },
        furniture: {
          label: 'В квартирі є',
        },
        renting_for_short_period_is_available:
          'Можна орендувати на короткий термін',
      },
      autocomplete: {
        new_building: 'Новобудова',
        cottage: 'Котеджне містечко',
        region: 'Область',
        city: 'Місто',
        district: 'Район',
        street: 'Вулиця',
        orient: 'Орієнтир',
        subway: 'Метро',
        house: 'Будинок',
        not_found: 'Не знайдено',
        multi_query: 'Вулиця, Орієнтир, ЖК'
      },
      options: {
        not_exist: 'Немає',
        exist: 'Є',
        yes: 'Так',
        no: 'Ні',
      },
    },
    exclusive_part: {
      cashback_verificated: 'Отримуйте кешбек 50% на просування ексклюзивних оголошень без комісії',
      cashback_nonverificated: '{bankid_link}, щоб підтвердити договір',
      verified_text_ask: 'Бажаєте верифікувати договір?',
      verified_text_kiev: 'Верифікований ексклюзив має кешбек 50% (за умови, що він без комісії), статус “ексклюзив” та представництво в картці на ЛУН і Flatfy',
      verified_text_other: 'Верифікований ексклюзив має статус “ексклюзив” та представництво в картці на ЛУН і Flatfy',
      verified_text_remark: 'Оберіть зручний для вас спосіб верифікації:',
      verified_text_field_reg_num: 'За реєстраційним номером нерухомості',
      verified_text_field_inn: 'За ІПН власника (за згодою власника)',
      verified_text_remark_3: 'За витягом з реєстру або іншими документами, якщо нерухомість відсутня {link} (можна прикрити по-батькові замовника, але повна адреса має бути відкритою)',
      verified_text_remark_3_link_text: 'у відкритому реєстрі',
    },
    hints: {
      exclusive_docs: {
        1: 'Завантажте скан-копію договору з власником в опубліковане оголошення в одному з форматів: jpeg / jpg, png, pdf',
        2: "В договорі мають бути адреса об'єкта, ціна, термін дії, відкриті дані замовника (паспортні дані/ідентифікаційний код).\n" +
          "Також дані виконавця у договорі мають збігаютися з даними рієлтора, який зареєстрований на сайті. Якщо договір створено на агентство, рієлтор має бути прив’язаний до агентства на сайті.",
        3: 'Інформація доступна лише модераторам сайту.',
        4: 'Завантаження підроблених документів є порушенням правил сайту і призводить до блокування профілю.',
        verified_reg_num_1: 'Будь ласка, введіть реєстраційний номер нерухомості або ІПН власника, щоб ми могли перевірити дані у відкритому реєстрі нерухомого майна.',
        verified_reg_num_2: 'Ми зобов\'язуємось не розголошувати ці дані третім особам (Загальні правила, п.3)'
      },
      pay_commission: 'Ділюся комісією з колегами (інформація доступна тільки для рієлторів)',
      commission_rate: 'комісія «з покупця/орендатора»',
      deals_hint: 'Закрита інформація - доступна тільки вам',
      change_location: 'Ви можете змінити положення мітки на карті',
      map_placeholder: 'Натисніть, щоб відкрити карту',
      orient:
        'У картці оголошення буде відображатись один орієнтир',
      inn: 'Надана інформація не буде відображатись в оголошенні і буде використовуватись тільки для підтвердження права власності'
    },
    low_balance_description:
      'Недостатньо балансу для публікації оголошення. {link}',
    low_balance_description2:
      'Недостатньо балансу для публікації оголошення. Вам необхідно зберегти чернетку і поповнити рахунок для публікації.',
    low_balance_description3:
      'Недостатньо балансу для публікації оголошення, тому ви можете зберегти чернетку, щоб опублікувати пізніше.',
    payment: 'Поповнити',
    activation: {
      title: 'Опублікувати оголошення',
      description:
        'Ви впевнені, що хочете опублікувати {count, plural, one {оголошення} few {# оголошення} other {# оголошень}}? {cost, select, 0 {} other {Добове списання становитиме {cost}.}}',
    },

  },
  payment_screen: {
    html_title: 'Поповнення',
    title: 'Поповнення',
    gift_title: 'Поповнити рахунок рієлтору {username}',
    exchange_description: 'Курс: 1 грн = {exchangeRate} монет',
    gift_alert: 'Ви даруєте поповнення рієлтору {username}.\n' +
      'Кошти буде зараховано на кабінет користувача.',
    input_title: 'Сума',
    bonus: 'Бонус: {bonus, plural, other {#%}}',
    pay: 'Cплатити {sum} грн',
    gift_pay: 'Привітати',
    bonuses_title: 'Бонусні відсотки за поповнення рахунку',
    bonuses_rieltor_title: 'Отримайте бонуси від суми поповнення',
    bonuses_owner_title: 'Бонус при поповненні рахунку для верифікованих власників',
    bonuses_title_verification: '{link} свій профіль та отримайте бонуси від суми поповнення',
    bonuses_title_verification_link: 'Верифікуйте',
    contract_liqpay: 'Оферта LiqPay',
    contract_stripe: 'Оферта Stripe',
    contract_monobank: 'Оферта Monobank',
    contract_common: 'Оферта',
    pay_amount: 'До сплати'

  },

  housing_cost_calculation_request: {
    bad_request: {
      title: 'Заявка на розрахунок вартості житла',
      create_request: 'Подати заявку',
    },
    form: {
      title: {
        first: 'Напишіть нам у viber',
        second: 'або заповніть заявку на продаж та оцінку самостійно',
      },
      write_to_viber: 'Написати у {icon} Viber',
      address: {
        title: `Адреса об'єкта`,
        placeholder: 'Вулиця, будинок',
      },
      area: {
        title: 'Метраж',
        placeholder: 'Площа, м²',
      },
      photos: {
        title: 'Фото',
      },
      phone: {
        title: `На який номер вам зручно отримати пропозиції? \n(У вайбер{icon})`,
        description: 'Ваші контакти без дозволу третім особам не передаються',
      },
      send: 'Відправити',
    },
    success: {
      title: 'Заявка успішно надіслана',
      description:
        'Ви отримаєте інформацію про вартість оціненого житла на номер\n{phone}',
      goto_main_page: 'На головну',
    },
  },

  verification_code_input: {
    code_from_sms: 'код з смс',
    did_not_receive: 'не прийшов',
  },
  form_fields: {
    phone: {
      title: 'телефон',
      placeholder: '50 123-45-67',
    },
    password: {
      title: 'пароль',
    },
    new_password: {
      title: 'новий пароль',
    },
  },

  validation_errors: {
    common: {
      required: 'Необхідно заповнити поле',
      required_multiple: 'Необхідно заповнити поля відмічені *',
      autocomplete_required: 'Необхідно вибрати елемент зі списку',
      min_length:
        'Довжина повинна бути не менша за {length, plural, one {# символа} few {# символів} many {# символів}}',
      max_length:
        'Довжина не повинна перевищувати {length, plural, one {# символ} few {# символи} many {# символів}}',
      max_items:
        'Можна вибрати максимум {count, plural, one {# варіант} few {# варіанти} many {# варіантів}}',
      min_value: 'Значення має бути більше {value}',
      max_value: 'Значення має бути менша {value}',
      integer: 'Повинно бути цілим числом',
      number: 'Повинно бути числом',
      chars_only: 'Допускаються тільки літери (кирилиця), дефіс та пробіл',
      house_number: 'Має починатись з цифри. Допускаються літери (кирилиця), дефіс, пробіл та /',
      not_symbols: 'Заборонені символи',
      not_numbers: 'Це поле не може містити цифри або кількість цифр перевищує допустиме',
    },
    phone: {
      not_valid: 'Неправильний номер телефону',
    },
    email: {
      not_valid: 'Неправильний email',
      not_unique: 'Email уже зареєстровано',
    },
    inn: {
      not_valid: 'Неправильний РНОКПП',
    },
    url: {
      not_valid: 'Неправильний URL',
    },
    number: {
      not_valid: 'Повинно бути числом',
    },
    payment_amount: {
      min_value: 'Сума повинна бути не менша, ніж {value} грн',
    },
    cadastral_number: {
      not_valid:
        'Неправильний кадастровий номер.',
    },
    personal_photo: {
      no_person: 'Необхідно завантажити особисте фото',
    },
    offer_position: {
      not_within_the_selected_city:
        'Точка на карті знаходиться в іншому місті ніж той, що вказано. Перевірте, будь ласка, та виправте',
      not_within_the_selected_district:
        'Точка на карті знаходиться в іншому районі ніж той, що вказано. Перевірте, будь ласка, та виправте',
      not_within_the_selected_residential:
          'Точка на карті знаходиться за межами ЖК. Перевірте, будь ласка, та виправте',
      not_within_the_selected_area_polygon:
          'Точка на карті знаходиться за межами ділянки за кадастровим номером. Перевірте, будь ласка, та виправте',
    },
    youtube: {
      not_valid: 'Додайте посилання на YouTube'
    },
    videoLink: {
        not_valid: 'Посилання повинно бути з YouTube або TikTok',
    },
    tiktok: {
      not_valid: 'Додайте посилання на TikTok'
    },
    facebook: {
      not_valid: 'Додайте посилання на Facebook'
    },
    instagram: {
      not_valid: 'Додайте посилання на Instagram'
    },
    about: {
      has_url: 'Посилання в тексті не допускаються',
      has_phone: 'Телефони в тексті не допускаються',
    }
  },
  api_errors: {
    image_mime_type: 'Неправильний тип файлу. Дозволені формати: {allowed_mime_types}',
    image_extension: 'Неправильний тип файлу. Дозволені формати: {allowed_extensions}',
    too_many_deals_requests: 'Ви досягли ліміту запитів на сьогодні. Спробуйте завтра',
    image_size_limit: 'Розмір файлу перевищує {file_size} Мб',
    wrong_format: 'Неправильний формат файлу',
    user_not_deleted: 'Користувача не видалено',
    user_deleted: 'Профіль користувача видалено, але ви можете відновити його',
    empty_data: 'Заповніть дані',
    free_limit_exceed: 'Ліміт безкоштовних оголошень перевищено',
    phone_not_found: 'Номер не зареєстрований',
    phone_not_valid: 'Неправильний номер телефону',
    code_not_valid: 'Неправильний код підтвердження',
    phone_already_registered: 'Номер вже зареєстрований',
    password_not_valid: 'Невірний пароль',
    email_already_exists: 'Користувач з таким email вже зареєстрований',
    agency_already_exists: "Агентство з таким ім'ям уже існує",
    offer_insufficient_funds: 'Недостатньо монет для активації оголошення',
    phone_not_confirmed: 'Необхідно підтвердити номер телефону',
    user_not_activated:
      'Необхідно підтвердити email. Код активації був висланий вам на пошту',
    user_has_not_email: 'У вас відсутній email',
    refresh_update_limit: 'Перевищено ліміт оновлень оголошення',
    not_enough_balance: 'Недостатньо балансу',
    already_offers_accepted: 'Ви вже отримали безкошт овні оголошення',
    already_offers_sent: 'Вже відправили повідомлення на вказаний номер',
    captcha_empty:
      'Реєстрація недоступна. Якщо у вас виникли запитання, зверніться в службу підтримки 097 154 85 32',
    wrong_captcha:
      'Реєстрація недоступна. Якщо у вас виникли запитання, зверніться в службу підтримки 097 154 85 32',
    banned_ip:
      'Реєстрація недоступна. Якщо у вас виникли запитання, зверніться в службу підтримки 097 154 85 32',
    user_is_banned:
      'Дія недоступна. Якщо у вас виникли запитання, зверніться в службу підтримки 097 154 85 32',
    renta_images_required: "Фото обов'язкове при подачі оголошення",
    renta_images_min3_required: 'Додайте не менше 3 фотографій обʼєкту',
    renta_address_invalid: 'Перевірте правильність адреси',
    minimal_photo_size: 'Фото низької якості',
    bankid_already_verified: 'Ви вже верифіковані',
    bankid_only_for_rieltors: 'Верифікація доступна лише рієлторам',
    bankid_already_failed_limit: 'Ліміт можливих верифікацій вичерпано',
    bankid_general_error: 'Невідома помилка',
    need_moderate: 'Ваше оголошення на модерації',
    user_has_referral: 'Ви уже переходили за посиланням іншого користувача',
    referral_already_bankid: 'Ви вже пройшли верифікацію. Послуга недоступна',
    referral_only_for_rieltors: 'Послуга доступна лише рієлторам',
    wrong_price: ' Некоректна ціна',
    geo_restrict_error: 'Публікація оголошень недоступна у даному регіоні',
    offer_banned: 'Ваше оголошення заблоковане модераторами',
    partners_same_user: 'Не можна додати в партнери себе',
    partners_for_rieltors_only: 'Додати у партнери можна користувачів зі статусом Рієлтор',
    partners_for_verified_rieltors_only: 'Розділ “Мої партнери” доступний для верифікованих користувачів.  Щоб додати рієлтора у партнери, він має верифікуватись',
    partner_already_requested: 'Ви вже запросили цього рієлтора',
    partner_already_registered: 'Даний рієлтор вже є вашим партнером',
    bird_premium_not_available: 'Передплата пакету "Преміум" недоступна для цього оголошення',
    lun_top_not_available: 'Передплата пакету "Преміум" недоступна для цього оголошення',
    cadastral_number_required: 'Вкажіть кадастровий номер',
    cadastral_number_invalid: 'Неправильний кадастровий номер',
    renta_items_restricted: 'Оголошення недоступне для публікації',
    general_payment_error: 'Щось пішло не так, спробуйте через декілька хвилин',
    shift_error: 'Зараз триває перерахунок за добу, оплата тимчасово недоступна. Спробуйте пізніше',
    user_sub_cancelled: 'Підписка уже скасована',
    already_has_deals: 'У вас уже є угода по цьому оголошенню',
    deals_verification_status_0: 'Угода по цьому об\'єкту ще на перевірці',
    deals_verification_status_1: 'Угоду по цьому об\'єкту вже було верифіковано',
    deals_verification_reason_not_found: 'Ми не знайшли нерухомість в реєстрі',
    deals_verification_same_number: 'Ви вже проходили верифікацію по цьому номеру',
  },
  errors: {
    general: 'Щось пішло не так, спробуйте через декілька хвилин',
  },
  locales: {
    [Locale.RU]: {
      name: 'Русский',
      short_name: 'Ру',
    },
    [Locale.UK]: {
      name: 'Українська',
      short_name: 'Укр',
    },
  },
  images_uploader: {
    upload_images: 'Завантажити фото',
    drag_and_drop: 'або перетягніть їх сюди',
    make_main_image: 'зробити головним',
    main_image: 'головне фото',
    avatar_requirements:' Максимум {file_size} Мб, формат: {formats}',
    image_requirements:
      'Максимум {file_size} Мб одне фото, розмір від {resolution}, формат: {formats}',
    upload_failure:
      'Не вдалося завантажити {count, plural, one {# фотографію} few {# фотографії} other {# фотографій}}',
    min_images_count: 'Додайте не менше {count, plural, one {# фотографію} few {# фотографії} other {# фотографій}} обʼєкту',
  },
  files_uploader: {
    upload_images: 'Завантажити файли',
    drag_and_drop: 'або перетягніть їх сюди',
    delete: 'Видалити',
  },
  dialog_actions: {
    ok: 'OK',
    cancel: 'Скасувати',
  },
  olx_import_management: {
    approve: 'Підтверджую, що це оголошення відповідає {link} і я несу всю відповідальність за його рекламу',
    approve_link: 'Правилам сайту',
    header_alert: 'У цьому розділі розміщено оголошення з Інтернету від власників, створені за останні 30 днів. Ви можете стати першим, хто їх рекламуватиме.',
    author: {
      owner: 'Власник',
      rieltor: 'Рієлтор',
    },
    buttons: {
      import: 'В чорновики',
    },
    filters: {
      any_value: 'Будь-який',
      id: 'Id',
      city: 'Місто',
      address: 'Адреса',
      import: 'Рекламувати на Rieltor',
      rooms: 'Кімнат',
      district: 'Район',
    }
  },
  agency_feed_management: {
    approve: 'Підтверджую, що це оголошення відповідає {link} і я несу всю відповідальність за його рекламу',
    approve_link: 'Правилам сайту',
    header_alert: 'У цьому розділі розміщено оголошення з Інтернету, додані за 7 днів, які ще не були представлені на Rieltor. Ви можете стати першим, хто їх рекламуватиме.',
    author: {
      owner: 'Власник',
      rieltor: 'Рієлтор',
    },
    buttons: {
      import: 'В чорновики',
    },
    filters: {
      any_value: 'Будь-який',
      id: 'Id',
      city: 'Місто',
      address: 'Адреса',
      import: 'Рекламувати на Rieltor',
      rooms: 'Кімнат',
      district: 'Район',
    }
  },
  offer_chips: {
    modes: {
      offers: 'Мої оголошення',
      internet: 'Оголошення з інтернету від власників',
      agency: 'Оголошення агентства'
    }
  },
  deals_management:  {
    csv_export_error: 'Помилка вигрузки в CSV, спробуйте ще раз через декілька хвилин',
    agents_month_report: {
      rieltor: 'Рієлтор',
      office: 'Філія',
      total: 'Всього',
      section: 'Розділ',
    },
    modes: {
      list: 'Стрічка угод',
      month_report: 'Угоди рієлторів по місяцях',
      office_report: 'Угоди філій по місяцях',
      rieltor_deals: 'Мої угоди',
      partner_deals: 'Угоди партнерів',
      agency_deals: 'Угоди АН',
      asnu_deals: 'Угоди АФНУ',
      sfnu_deals: 'Угоди СФНУ',
      global_deals: 'Угоди на ринку',
    },
    buttons: {
      delete: 'Видалити угоду',
      deals_export: 'Вигрузити в CSV',
    },
    actions: {
      update_verified_deal: {
        title: 'Відредагувати номер нерухомості',
        success: 'Угоду відправлено на повторну перевірку',
      },
      change_reason: {
        question: 'Ви впевнені, що хочете видалити угоду?',
        title: 'Видалення угоди',
        success:
          '{count, plural, one {Угода} other {Угоди}} успішно {count, plural, one {видалена} other {видалени}}',
      },
    },
    deals_move: {
      title: 'Оголошення перенесене до ваших угод',
      description:
        'Оголошення {offerId} {count, plural, one {перенесене} few {перенесені} many {перенесені}} в розділ',
      my_deals: 'Мої угоди',
    },
  },
  offer_report:{
    title: 'Звіт по рекламі',
    send_report: 'Надіслати звіт власнику',
    notification: {
      share_problem: 'share_problem',
    },
    description_no_selected: 'Виберіть хоча б одне оголошення, про яке бажаєте подивитись звіт.',
    blocks: {
      published: {
        title: 'Опубліковано на:',
      },
      ads: {
        title: 'Рекламні функції:',
        pos_city: 'Позиція на сайті',
        pos_region: 'Позиція по області',
        autoupdate: 'Автооновлення',
        quickly: 'Велике фото'
      },
      statistics: {
        title: 'Cтатистика:',
        published: 'Публікується',
        exposition: 'Термін експозиції',
        spent: 'Витрачено',
        views: 'Переглядів оголошень',
        contacts: 'Покази контактів',
        viber: 'Написати в Viber/Telegram',
        favorite: 'Додавань у обране',
      },
      views: {
        title: 'Перегляди по дням:',
      }
    },
    switchers: {
      active: 'Підключено',
      inactive: 'Не підключено',
    }
  },
  offers_management: {
    no_an_offers: {
      list_title1: 'Публікація оголошень доступна для зареєстрованих користувачів в ролі “Рієлтор” чи “Власник“.',
      list_title2: 'Зареєструйте рієлторів вашого АН на RIELTOR.UA, та привʼяжіть їхні акаунти до АН, щоб:',
      title: 'У вас ще немає оголошень',
      list_item_1: 'бачити в кабінеті всі оголошення, створені вашими рієлторами,',
      list_item_2: 'бачити сукупну статистику та витрати по оголошенням ваших рієлторів,',
      list_item_3: 'поповнювати баланс вашим рієлторам,',
      list_item_4: 'оголошення рієлторів були брендовані логотипом вашого АН',
    },
    notification: {
      copy_id: 'ID скопійовано в буфер обміну',
      copy_success: 'Посилання на оголошення скопійовано в буфер обміну',
    },
    pickup_success: 'Рекламна ставка успішно змінена',
    save_for_rieltor_popover: {
      title: 'Зверніть увагу!',
      description:
        'Ми створили для вас особисту базу оголошень. Тепер ви можете безкоштовно зберігати необмежену кількість пропозицій та відправляти їх вашим клієнтам.',
      more: 'Детальніше',
    },
    actions: {
      pickup: {
        title: 'Підняття оголошень',
        description_no_selected: 'Оберіть оголошення, яке бажаєте підняти',
      },
      trash: {
        title: 'Очистити видалені',
        description:
          'Ви впевнені, що хочете очистити ВСІ видалені оголошення з кабінету?',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте видалити.',
        success:
          'Оголошення успішно видалені',
      },
      to_deals: {
        dialogTitle: 'Записати оголошення в Мої угоди ',
        title: 'Записати оголошення в Мої угоди ',
        title_with_price: 'Записати оголошення за ціною {price} в Мої угоди ',
        description_no_selected: 'Виберіть оголошення, яке бажаєте перенести в угоди',
        success: 'Оголошення перенесено в угоди',
        verification: 'Верифікувати угоду',
        reg_number_hint: 'Будь ласка, вкажіть номер нерухомості.',
        cadastral_hint: 'Будь ласка, вкажіть кадастровий номер.',
        verification_bonus: 'Після успішного проходження верифікації користувач отримає бонус {bonus}₴',
        verification_text: 'Ми зробимо за ним запит до відкритого реєстру\n' +
          'нерухомого майна, щоб перевірити, чи змінилась\n' +
          'інформація щодо права власності впродовж 30 днів з\n' +
          'моменту вашого запиту на верифікацію.\n\n' +
          'Якщо зміна власності відбулась, ми верифікуємо цю угоду.'
      },
      partners: {
        title: 'Перенесення оголошень до закритої бази',
        description:
          'Ви впевнені, що хочете перенести оголошення до закритої бази?',
        success: 'Оголошення перенесене до закритої бази',
        description_no_selected: 'Виберіть оголошення, яке бажаєте перенести до закритої бази',
      },
      edit: {
        title: 'Редагування оголошень',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте редагувати.',
      },
      delete: {
        title: 'Видалення оголошень',
        description:
          'Ви впевнені, що хочете видалити {count, plural, one {оголошення} few {# оголошення} other {# оголошень}}?',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте видалити.',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {видалено} other {видалені}}',
      },
      lost: {
        title: 'Видалення оголошень',
        description:
          'Ви впевнені, що хочете видалити {count, plural, one {оголошення} few {# оголошення} other {# оголошень}} НАЗАВЖДИ ?',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте видалити.',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {видалено} other {видалені}}',
      },
      refresh: {
        title: 'Підтвердження актуальності оголошення',
        description:
          'Ви впевнені, що хочете підтвердити актуальність {count, plural, one {оголошення} few {# оголошень} other {# оголошень}}?',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте оновити.',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {оновлено} other {оновлені}}',
      },
      draft: {
        title: 'Перенесення оголошень в чернетки',
        description:
          'Ви впевнені, що хочете перенести в чернетки {count, plural, one {оголошення} few {# оголошення} other {# оголошень}}?',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте перенести в чернетки.',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {перенесено} other {перенесені}} в чернетки',
      },
      delay: {
        title: 'Відкласти оголошення',
        description:
          'Ви впевнені, що хочете відкласти {count, plural, one {оголошення} few {# оголошення} other {# оголошень}}?',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте відкласти.',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {відкладено} other {відкладені}}',
      },
      activate: {
        title: 'Опублікувати оголошення',
        description:
          'Ви впевнені, що хочете опублікувати {count, plural, one {оголошення} few {# оголошення} other {# оголошень}}? {cost, select, 0 {} other {Добове списання становитиме {cost}.}}',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте опублікувати.',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {опубліковане} other {опубліковані}}',
      },
      copy: {
        title: 'Опублікувати оголошення',
        description:
          'Ви впевнені, що хочете опублікувати {count, plural, one {оголошення} few {# оголошення} other {# оголошеннь}}? {cost, select, 0 {} other {Добове списання становитиме {cost}.}}',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте опублікувати.',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {опубліковане} other {опубліковані}}',

      },
      reactivate: {
        title: 'Опублікувати оголошення',
        description: 'Оголошення було неактивне понад місяць. Ви можете опублікувати його зі старою або новою датою створення.',
        description_limit: 'Функція створення оголошення з новою датою доступна раз в 30 днів.',
        optionCopy: 'З новою датою',
        optionActivateOld: 'Зі старою датою',
        success: 'Нове оголошення опубліковано, ID: {id}.',
        failed: 'Під час копіювання оголошення {id} виникла помилка.'
      },
      moderate: {
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} {count, plural, one {відправлено} other {відправлени}} на модерацію',
      },
      restore: {
        title: 'Опублікувати оголошення',
        description:
          'Ви впевнені, що хочете опублікувати {count, plural, one {оголошення} few {# оголошення} other {# оголошень}}? {cost, select, 0 {} other {Добове списання становитиме {cost}.}}',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {опубліковане} other {опубліковані}}',
      },
      save_for_rieltor: {
        title: 'Перемістити до пропозицій',
        description:
          'Ви впевнені, що хочете перемістити до пропозицій {count, plural, one {оголошення} few {# оголошення} other {# оголошень}}?',
        description_no_selected:
          'Виберіть оголошення, яке бажаєте перемістити до пропозицій.',
        success:
          '{count, plural, one {Оголошення} other {Оголошення}} успішно {count, plural, one {перенесено} other {перенесені}} до пропозицій',
      },
      unpublish: {
        user_price_field: 'Ціна угоди',
        question:
          'Чому ви хочете зняти {count, plural, one {оголошення} few {# оголошення} other {# оголошень}} з публікації?',
        other: 'Інше',
        comment: 'Коментар',
        max_value: 'Перевірте ціну',
      },
      report: {
        title: 'Звіт по рекламі',
        description_no_selected: 'Виберіть оголошення, про яке бажаєте подивитись звіт.',
      },
    },
    updated_at: {
      today: 'Сьогодні',
      today_short: 'Сьог.',
      yesterday: 'Вчора',
    },
    ok: 'OK',
    cancel: 'Скасувати',

    add_offer: 'Додати оголошення',
    add_offer_short: 'Додати',
    pickup: 'Підняти',
    edit: 'Редагувати',
    delete: 'Видалити',
    delete_forever: 'Видалити назавжди',
    to_deal: 'В угоди',
    empty_trash: 'Очистити видалені',
    to_partner: 'В закриту базу',
    refresh: 'Оновити дату актуальності',
    refresh_short: 'Оновити',
    activate: 'Опублікувати',
    share: 'Поділитися',
    copy: 'Поділитися',
    report: 'Звіт власнику',
    moderate: {
      label: 'На модерації',
      title:
        "Ваше оголошення з'явиться на сайті відразу після перевірки модераторами",
    },
    wait_banned: {
      label: 'Забанен',
      title:
        "Ваше оголошення з'явиться на сайті відразу після перевірки модераторами",
    },
    draft: 'В чорновики',
    save_for_rieltor: 'Перемістити до пропозицій',
    delay: 'Відкладено',

    not_found: 'Не знайдено',

    columns: {
      edit: 'Ред.',
      pickup_or_activate: 'Підняти/\nОпублікувати',
      services: 'Публікація',
      share: 'Поділитися',
      rieltor: 'Рієлтор',
      flatfy: 'Оголошення на Flatfy',
      lun: 'Оголошення на Lun',
      lun_representative_active: 'Оголошення є представником на ЛУН',
      flatfy_representative_active: 'Оголошення є представником на Flatfy',
      lun_representative_can: 'Підніміть оголошення, щоб стати представником на ЛУН',
      flatfy_representative_can: 'Підніміть оголошення, щоб стати представником на Flatfy',
      lun_representative_cannot: 'На даний момент представництво неможливе',
      lun_representative_cannot_luntop: 'Інший користувач підключив ЛУН Топ по цьому обʼєкту',
      flatfy_representative_cannot: 'На даний момент представництво неможливе',
      flatfy_representative_cannot_luntop: 'Інший користувач підключив ЛУН Топ по цьому обʼєкту',
      bird: 'Оголошення на Bird',
      lun_top: 'Підключено Лун Топ',
    },
    filters: {
      any_value: 'Будь-який',
      id: 'Id',
      city: 'Місто',
      district: 'Район',
      address: 'Адреса',
      rieltor: 'Рієлтор',
      office: 'Філія',
      currency: 'Валюта',
      year: 'Рік',
      rooms: 'Кімнат',
      price: 'Ціна за',
      offices: 'Філія',
      period: 'Дати угод'
    },
    exclusive: {
      [ExclusiveStatus.New]: 'На перевірці',
      [ExclusiveStatus.Accepted]: 'Ексклюзив: {comment}',
      [ExclusiveStatus.Hold]: 'Зауваження до ексклюзиву: {comment}',
      [ExclusiveStatus.Deleted]: '',
      [ExclusiveStatus.VerifiedAccepted]: 'Верифікований ексклюзив. Обʼєкт підтверджено.',
    },
    premium_label: {
      [PremiumType.Premium]: 'ПРЕМІУМ',
      [PremiumType.Urgent]: 'ТЕРМІНОВО',
      [PremiumType.Torg]: 'ТОРГ',
      [PremiumType.Hot]: 'ГАРЯЧЕ',
      [PremiumType.Action]: 'АКЦІЯ',
      [PremiumType.Profitable]: 'ВИГІДНО',
      [PremiumType.Elite]: 'ЕЛІТ',
    },
    description: {
      title: 'Зверніть увагу!',
      text: 'Ви можете публікувати {freeOfferLimit, plural, one {{freeOfferLimitHighlighеed} оголошення} other {до {freeOfferLimitHighlighеed} оголошень}} безкоштовно протягом {monthName}.\n{detailsLink}',
      details_link: 'Докладніше про платні оголошення',
    },
    free_offers_super_rule_description: {
      title: 'Ви можете отримати {futureOfferLimit, plural, one {# безкоштовне оголошення} few {# безкоштовні оголошення} other {# безкоштовних оголошень}}',

      not_verified_title: '{link} та отримайте можливість розміщувати {futureOfferLimit, plural, one {# оголошення} few {# оголошення} other {# оголошень}} безкоштовно.',
      not_verified_title_with_limit: '{link}, щоб розміщувати {futureOfferLimit, plural, one {# оголошення} few {# оголошення} other {# оголошень}} безкоштовно, а також отримати {coins} монет для активації рекламних послуг і просування ваших об\'єктів.',
      not_verified_title_link: 'Верифікуйте ваш профіль',

      not_verified_subtitle_rieltor: 'А також, отримайте доступ до бонусів при поповненні рахунку (до 30%) та участь у {link}.',
      not_verified_subtitle_owner: 'А також, отримайте доступ до бонусів при поповненні рахунку (до 10%) та позначку верифікованого власника у видачі оголошень',
      not_verified_subtitle_link: 'рейтингу рієлторів',

      not_viber_title: '{link} та отримайте можливість розміщувати {futureOfferLimit, plural, one {# оголошення} few {# оголошення} other {# оголошень}} безкоштовно.',
      not_viber_title_with_limit: '{link}, щоб розміщувати {futureOfferLimit, plural, one {# оголошення} few {# оголошення} other {# оголошень}} безкоштовно, а також отримати {coins} монет для активації рекламних послуг і просування ваших об\'єктів.',
      not_viber_title_link: 'Підтвердіть Viber',
      not_viber_subtitle: '{link}',
      not_viber_subtitle_link: 'Детальніше про платні оголошення.',

      not_all_title: '{link2}, щоб мати можливість опублікувати оголошення, а також {link1}, щоб отримати можливість розміщувати {futureOfferLimit, plural, one {# оголошення} few {# оголошення} other {# оголошень}} безкоштовно.',
      not_all_title_limit: '{link1} та {link2}, щоб розміщувати {futureOfferLimit, plural, one {# оголошення} few {# оголошення} other {# оголошень}} безкоштовно, а також отримати {coins} монет для активації рекламних послуг і просування ваших об\'єктів.',
      not_all_title_link1: 'Підтвердіть Viber',
      not_all_title_link2: 'Верифікуйте ваш профіль',
      not_all_subtitle_rieltor: 'А також, отримайте доступ до бонусів при поповненні рахунку (до 30%) та участь у {link}.',
      not_all_subtitle_owner: 'А також, отримайте доступ до бонусів при поповненні рахунку (до 10%) та позначку верифікованого власника у видачі оголошень.',
      not_all_subtitle_link: 'рейтингу рієлторів',

      all_title: 'Зверніться в нашу службу підтримки щоб отримати можливість розміщувати оголошення безкоштовно.',

      accepted_title: 'Ви можете публікувати {freeOfferLimit, plural, one {{freeOfferLimitHighlighеed} оголошення} other {до {freeOfferLimitHighlighеed} оголошень}} безкоштовно.\n{detailsLink}',
      details_link: 'Докладніше про платні оголошення',
    },
    free_coins: {
      title: 'Отримайте {coins} грн на рахунок від Rieltor',
      title_with_limit: 'Ви можете отримати {futureOfferLimit, plural, one {# безкоштовне оголошення} few {# безкоштовні оголошення} other {# безкоштовних оголошень}} та {coins} грн на рахунок від Rieltor',

      not_verified_title: '{link} щоб отримати {coins} грн.',
      not_verified_title_offer_form: '{link} щоб отримати {coins} грн для розміщення оголошень та використання рекламних функцій.',
      not_verified_title_offer_form_with_limit: '{link}, щоб отримати можливість розміщувати {futureOfferLimit, plural, one {# оголошення} few {# оголошення} other {# оголошень}} безкоштовно та {coins} грн для розміщення оголошень та використання рекламних функцій',
      not_verified_title_link: 'Верифікуйте ваш профіль',
      not_verified_subtitle_rieltor: 'А також, отримайте доступ до бонусів при поповненні рахунку (до 30%) та участь у {link}.',
      not_verified_subtitle_link: 'рейтингу рієлторів',

      not_viber_title: '{link} щоб отримати {coins} грн',
      not_viber_title_offer_form: '{link} щоб отримати {coins} грн для розміщення оголошень та використання рекламних функцій.',
      not_viber_title_link: 'Підтвердіть Viber',
      not_viber_subtitle: '{link}',
      not_viber_subtitle_link: 'Детальніше про платні оголошення.',

      not_all_title: '{link1} та {link2}, щоб отримати {coins} грн.',
      not_all_title_offer_form: '{link1} та {link2}, щоб отримати {coins} грн  для розміщення оголошень та використання рекламних функцій.',
      not_all_title_link1: 'Підтвердіть Viber',
      not_all_title_link2: 'верифікуйте ваш профіль',
      not_all_subtitle_rieltor: 'А також, отримайте доступ до бонусів при поповненні рахунку (до 30%) та участь у {link}.',
      not_all_subtitle_link: 'рейтингу рієлторів',
    },
    free_offers_description: {
      title:
        'Ви можете отримати {futureOfferLimit, plural, one {# безкоштовне оголошення} few {# безкоштовні оголошення} other {# безкоштовних оголошень}} на {monthName}',
      pickup_title: 'Щоб опублікувати безкоштовно -{link}',
      pickup_title_link:
        'отримайте {futureOfferLimit, plural, one {# оголошення} few {# оголошення} other {# оголошення}} в viber',
      text: 'Ми відправимо вам повідомлення у Viber на номер {phone} для нарахування {futureOfferLimit, plural, one {безкоштовного оголошення} other {безкоштовних оголошень}}.\nВи можете додати інший номер телефону {profileEditLink}.\nНе отримали повідомлення? {faqLink}',
      profile_edit_link: 'у редагуванні профілю',
      faq_link: 'Перевірте налаштування Viber',
      accept: 'Отримати у Viber',
      sent: 'Відправили повідомлення на {phone}',
    },
    view_stats:
      'ВСЬОГО: сьогодні - {today, number}, вчора - {yesterday, number}, за тиждень - {week, number}, всього - {allTime, number}.',
    unbanned_offers: {
      free_limit: '{count, plural, zero {Оголошень} one {Оголошення} few {Оголошення} other {Оголошень}} {offers} {count, plural, one {розблоковано} few {розблоковані} other {розблоковані}} модераторами та перенесене у Чорновики, оскільки ліміт публікації безкоштовних оголошень вичерпано. Ви можете опублікувати його на платній основі.',
      no_balance: '{count, plural, zero {Оголошень} one {Оголошення} few {Оголошення} other {Оголошень}} {offers} {count, plural, one {розблоковано} few {розблоковані} other {розблоковані}} модераторами та перенесене у Чорновики через недостатній баланс. Ви можете поповнити рахунок та опублікувати його.'
    },
    unpublished_offers: {
      alert: `{count, plural,
      one {# ваше оголошення потрапило}
      few {# ваших оголошення потрапили}
      other {# ваших оголошень потрапили}
    } у Чорновики через недостатній баланс. Ви можете {paymentLink} рахунок та відновити їх`,
      payment_link: 'поповнити',
      restore: 'Відновити',
      close: 'Закрити',
    },
    modes: {
      active: 'Опубліковані',
      partners: 'Закрита база',
      draft: 'Чорновики',
      moderate: 'На модерації',
      deleted: 'Видалені',
      banned: 'Забанені',
    }
  },
  coins: {
    value: '{sign}{value, number}{label}',
    value_with_label:
      '{sign}{value, plural, one {# монета} few {# монети} other {# монет}}{label}',
    coins_per_day:
      '{sign}{value, plural, one {# монета/добу} few {# монети/добу} other {# монет/добу}}',
    coins_discount: ' (знижка {value, number}%{text})',
    coins_message: '{value, plural, one {монета} few {монети} other {монет}}',
    coins_per_day_message: '{value, plural, one {монета/добу} few {монети/добу} other {монет/добу}}',
  },
  coins_in_currency: {
    value: '{sign}{value} {currency}{label}',
    value_per_day: '{sign}{value} {currency}/добу',
    value_message: '{currency}',
    value_per_day_message: '{currency}/добу',
  },
  currency: {
    [UIPriceCurrency.UAH]: '₴',
    [UIPriceCurrency.USD]: '$',
    [UIPriceCurrency.EUR]: '€',
  },
  common: {
    price_uah: '{value, number} грн',
    additional_percents: '+ {value}%',
    currency_uah: 'грн',
    pluralize: {
      rooms: '{count, plural, =6 {6 кімнат і більше} one {# кімната} few {# кімнати} other {# кімнат}}',
    }
  },
  user_profile_menu: {
    rieltor_manifest: 'Я – RIELTOR',
    olx_import: 'Оголошення з інтернету від власників',
    agency_feed: 'Оголошення агентства',
    dashboard: 'Головна',
    my_deals: 'Угоди',
    an_deals: 'Угоди',
    my_offers: 'Оголошення',
    an_offers: 'Оголошення',
    profile: 'Налаштування',
    agents: 'Рієлтори',
    partners: 'Партнери',
    unions: 'Спільноти',
    top100: 'ТОП-100 АН України',
    stats: 'Статистика',
    my_site: 'Мій сайт',
    pro_subscription: 'Rieltor PRO',
    referrals: 'Запросити колег',
    messages: 'Повідомлення',
    logout: 'Вихід',
    offers_count:
      '{count, plural, zero {# оголошень} one {# оголошення} few {# оголошення} other {# оголошень}}',
    partners_count:
      '{count, plural, zero {# партнерів} one {# партнер} few {# партнера} other {# партнерів}}',
    game_quiz: 'Гра',
    market_activity: 'Ринок',
    market_activity_title: 'Ринок нерухомості {city}',
  },

  offer_status: {
    [OfferStatus.Active]: 'Активний',
    [OfferStatus.Rieltor]: 'Мої пропозиції',
    [OfferStatus.Archived]: 'Архівний',
    [OfferStatus.Deferred]: 'Відкладений',
    [OfferStatus.Deleted]: 'Видалений',
    [OfferStatus.Draft]: 'Чорновик',
    [OfferStatus.ModerateBlocked]: 'Розглядається',
    [OfferStatus.Moderate]: 'Розглядається',
    [OfferStatus.TempBanModerated]: 'Забанене',
    [OfferStatus.TempBanWait]: 'Розглядається',
  },

  item_type_select: {
    [ItemType.Flats]: 'Квартири',
    [ItemType.Rooms]: 'Кімнати',
    [ItemType.Houses]: 'Будинки',
    [ItemType.Commercial]: 'Комерційна',
    [ItemType.Parking]: 'Паркомісця',
    [ItemType.Land]: 'Земля',
  },

  oper_type_select: {
    [OperType.Sale]: 'Продаж',
    [OperType.Rent]: 'Оренда',
  },

  map_style_satellite: {
    false: 'Мапа',
    true: 'Супутник',
  },

  pickup: {
    services: {
      lun: 'ЛУН',
      flatfy: 'Flatfy',
      bird: 'Bird',
      rieltor: 'Rieltor',
    },
    need_verification: {
      //'Верифікуйтесь для публікації оголошення на {service}',
      lun: 'Верифікуйтесь для публікації оголошення на ЛУН',
      flatfy: 'Верифікуйтесь для публікації оголошення на Flatfy',
      bird: 'Верифікуйтесь для публікації оголошення на Bird',
    },
    cashback: 'Кешбек: {total}',
    modal_title: 'Підняти оголошення',
    modal_activate_title: 'Опублікувати оголошення',
    tabs: {
      rate: 'Витрата',
      city_place: 'Позиція по місту',
    },
    description:
      'Ви впевнені, що хочете підняти {count, plural, one {оголошення} few {# оголошення} other {# оголошень}}? Добове списання становитиме {cost}.',
    total: 'Разом: {total}',
    total_short: 'Разом:',
    add_promotion_title: 'Додайте послуги просування',
    add_promotion_subtitle: 'Кожна послуга підвищує позицію в пошуку',
    features: {
      bird1: 'Фіксоване представництво картки в застосунку Bird',
      bird2: 'Відсутність контактів власника і інших рієлторів',
      quick_title: 'Велике фото + мітка',
      quick_big_photo: 'Велике фото',
      additional_mark: 'Додаткова мітка',
      higher_position: 'Вища позиція у списку',
      select_mark: 'Оберіть мітку',
      autopickup_title: 'Автооновлення',
      lun_top_title_rieltor: 'Ваше фіксоване представництво в картці обʼєкта на ЛУН та Flatfy:',
      lun_top_title_owner: 'Найпотужніша послуга просування вашого обʼєкта на ЛУН та Flatfy:',

      lun_bird_top_title: 'Найпотужніша послуга просування вашого обʼєкта на ЛУН, Flatfy та в застосунку Bird:',
      lun_bird_top_active_title: 'Ваше оголошення є фіксованим представником картки на ЛУН, Flatfy та в застосунку Bird, поки ви самостійно не вимкнете цю функцію.',

      lun_top_agenda_rieltor_1: 'Відсутність контактів власника і інших рієлторів',
      lun_top_agenda_rieltor_2: 'Неможливо перебити більш високою ставкою',
      lun_top_agenda_rieltor_3: 'Найвищі позиції у пошуку',

      lun_bird_top_agenda_rieltor_1: 'Відсутність контактів власника і інших рієлторів',
      lun_bird_top_agenda_rieltor_2: 'Неможливо перебити більш високою ставкою',
      lun_bird_top_agenda_rieltor_3: 'Підняття на високі позиції у пошуку',

      lun_top_agenda_owner_1: 'Найвищі позиції у пошуку',
      lun_top_agenda_owner_2: 'Захист від перепублікацій рієлторами',

      lun_top_1: 'Фіксоване представництво картки на ЛУН та Flatfy',
      lun_top_2: 'Вища позиція у списку',
      lun_bonus_active_old: 'Ваше оголошення буде фіксованим представником картки на ЛУН та Flatfy, поки ви самостійно не відключите цю послугу.',
    },
    form: {
      chips: {
        region: 'По області',
        city: 'По місту',
      },
      city_place: 'Змінити позицію у пошуку по місту',
      quickly: 'Велике фото + мітка',
      autoupdate: 'Щоденне оновлення дати',
      bird_premium: 'Bird Top',
      bird_premium_select: 'Bird Top / Bird Select',
      rate: 'Витрату на добу',
      price_description: 'Ціна: {price}',
      min_price_description: 'Мінімум: {price}',
      calced_place: 'Очікувана позиція по місту: {place}',
      place: 'Позиція на Rieltor',
      representativity_label: '{coins_html}{coins, plural, one {# монета} few {# монети} other {# монет}} - ставка представника на ЛУН',
    },
    actions: {
      ok: 'OK',
      save: 'Внести зміни',
      activate_and_save: 'Опублікувати та підняти',
      activate: 'Опублікувати',
      cancel: 'Скасувати',
    },
    big_rate: {
      title_pickup: 'Ви піднімаєте оголошення {renta_item_id}',
      title_activate: 'Ви публікуєте оголошення {renta_item_id}',
      autoupdate: 'Щоденне оновлення дати',
      quickly: 'Велике фото + мітка',
      coins_per_day: 'Ставка: {value, plural, one {# монета/добу} few {# монети/добу} other {# монет/добу}}',
      modal_yes: 'Підтвердити',
      modal_no: 'Скасувати',
    },
    modal_generic_title: 'Підняття оголошень',
    not_selected: 'Оберіть хоча б одне оголошення, яке бажаєте підняти',

    multiple_pickup_alert:
      'Тепер ви можете підняти одразу кілька оголошень. Для цього оберіть потрібні галочками та натисніть "підняти"',
    lun_publication: '+ Публікація на',
    bird_publication_title: 'Зніми румтур — отримай Select і кешбек {percent}%',
    bird_publication_title_no_cashback: 'Зніми румтур - отримай додатково Select {free}',
    bird_publication_title_no_cashback_free: 'безкоштовно',
    bird_publication_short: 'Для отримання Select і кешбеку {percent}% зніміть рум-тур за {instruction_link} та відправте в {telegram_link} для верифікації',
    bird_publication_short_no_cashback: 'Для отримання додатково Select {free} зніміть рум-тур за {instruction_link} та відправте в {telegram_link} для верифікації',
    bird_publication_short_no_cashback_free: 'безкоштовно',
    bird_publication_list_1: '{telegram_link} та активуйте ТОП',
    bird_publication_telegram_link2: 'Додайте Telegram',
    bird_publication_list_2: 'Зніміть рум-тур за {instruction_link}.',
    bird_publication_list_3: 'Надішліть відео в {telegram_link} для верифікації.',
    bird_publication_list_4: 'Отримайте кешбек 100% 🤩',
    bird_publication_list_4_percent: 'Отримайте кешбек {percent}% 🤩',
    bird_publication_list_4_no_cashback: 'Отримайте просування SELECT',
    bird_publication_text: '- Активуйте послугу Top та отримайте фіксоване представництво в застосунку Bird. Після цього напишіть в {telegram_link}, щоб надіслати відеотур по об’єкту для активації Select та отримання кешбеку.',
    bird_publication_telegram_link: 'Telegram',
    bird_publication_instruction_link: 'інструкцією',
    bonus: 'Бонус',
    lun_bonus_disabled_bankid: 'Щоб активувати {bankid_link}',
    lun_bonus_disabled_viber: 'Щоб активувати {viber_link}',
    lun_bonus_disabled_without_commission: 'Щоб оголошення потрапило на ЛУН, {without_commission_link}',
    without_commission_activate: 'позначте його як “без комісії”',
    viber_activate: 'підключіть Viber',
    bird_bonus_disabled_bankid: 'Щоб активувати {bankid_link}',
    lunTop_bonus_disabled_bankid: 'Щоб активувати {bankid_link}',
    bird_bonus_disabled_telegram: '{telegram_link} та підключайте фіксоване представництво для вашого оголошення в Bird.',
    lun_bird_bonus_disabled_telegram: '{telegram_link} та підключайте фіксоване представництво для вашого оголошення в ЛУН, Flatfy та в застосунку Bird.',
    lun_bird_bonus_disabled_telegram_or_viber: '{telegram_viber_link} та підключайте фіксоване представництво для вашого оголошення в ЛУН, Flatfy та в застосунку Bird.',
    bird_bonus_active_old: 'Ваше оголошення буде фіксованим представником картки в застосунку Bird, поки ви самостійно не відключите цю послугу.',
    bird_bonus_active_new: 'Ми перевіримо, чи може ваше оголошення стати фіксованим представником картки в Bird та надішлемо повідомлення про це. Не відключайте Bird Top.',
    bird_top_reason_realty_is_marked_as_spam: 'Послуга недоступна. Bird позначив це оголошення, як “Спам“. Зверніться в {link}.',
    bird_top_reason_realty_is_marked_as_fake: 'Послуга недоступна. Bird позначив це оголошення, як “Фейк“. Зверніться в {link}.',
    bird_top_reason_realty_is_marked_as_sold: 'Послуга недоступна. Bird позначив це оголошення, як “Неактуальне“. Зверніться в {link}.',
    bird_top_reason_realty_is_excluded_by_complaint: 'Послуга недоступна. Bird заблокував це оголошення за результатами перевірки. Зверніться в {link}.',
    bird_top_reason_realty_is_not_found: 'Ми перевіряємо, чи може ваше оголошення стати фіксованим представником картки в Bird.',
    bird_top_reason_not_found: 'Ми перевіряємо, чи може ваше оголошення стати фіксованим представником картки в Bird.',
    bird_top_reason_deleted_page: 'Ми перевіряємо, чи може ваше оголошення стати фіксованим представником картки в Bird.',
    bird_top_reason_group_has_a_promoted_realty: 'Послуга недоступна, адже її активував інший користувач. Спробуйте пізніше.',
    bird_top_reason_realty_excluded_due_to_other_factors: 'Послуга недоступна. Зверніться в {link}.',
    bird_top_reason_realty_has_no_images: 'Послуга недоступна. Зверніться в {link}.',
    bird_top_reason_no_coordinates: 'Послуга недоступна. Bird перевірив оголошення та не знайшов місцезнаходження обʼєкту за координатами.',
    bird_top_reason_default: 'Послуга недоступна. Зверніться в {link}.',
    lun_top_reason_realty_is_marked_as_spam: 'Послуга недоступна. ЛУН позначив це оголошення, як “Спам“. Зверніться в {link}.',
    lun_top_reason_realty_is_marked_as_fake: 'Послуга недоступна. ЛУН позначив це оголошення, як “Фейк“. Зверніться в {link}.',
    lun_top_reason_realty_is_marked_as_sold: 'Послуга недоступна. ЛУН позначив це оголошення, як “Неактуальне“. Зверніться в {link}.',
    lun_top_reason_realty_is_excluded_by_complaint: 'Послуга недоступна. ЛУН заблокував це оголошення за результатами перевірки. Зверніться в {link}.',
    lun_top_reason_not_found: 'Ми перевіряємо, чи може ваше оголошення стати фіксованим представником картки в ЛУН та надішлемо повідомлення про це.',
    lun_top_reason_group_has_a_promoted_realty: 'Послуга недоступна, адже її активував інший користувач. Спробуйте пізніше.',
    lun_top_reason_realty_excluded_due_to_other_factors: 'Послуга недоступна. Зверніться в {link}.',
    lun_top_reason_realty_has_no_images: 'Послуга недоступна. Зверніться в {link}.',
    lun_top_reason_no_coordinates: 'Послуга недоступна. ЛУН перевірив оголошення та не знайшов місцезнаходження обʼєкту за координатами.',
    lun_top_reason_default: 'Послуга недоступна. Зверніться в {link}.',
    lun_top_reason_realty_is_not_found: 'Ми перевіряємо, чи ваше оголошення може мати фіксоване представництво в картці обʼєкта на ЛУН та Flatfy',
    lun_top_reason_deleted_page: 'Ми перевіряємо, чи ваше оголошення може мати фіксоване представництво в картці обʼєкта на ЛУН та Flatfy',

    bird_top_reason_link: 'службу підтримки',
    lun_top_reason_link: 'службу підтримки',
    bird_top_reason_low_quality_images: 'Послуга недоступна. Фото низької якості. Завантажте фото розміром від 800х600.',

    telegram_activate: 'Додайте телеграм',
    telegram_viber_activate: 'Додайте телеграм або viber',
  },
  header: {
    pay: 'Поповнити',
  },
  footer: {
    copyright: '© 2009 - {currentYear} «Rieltor.ua».\nВсі права захищені.',
    support_tel: 'Служба підтримки\n',
    support_schedule: 'Працюємо щодня з 9 до 18',
    support_holidays:
      "Зверніть увагу!\n23.08 - 24.08 команда Rieltor.ua не працює.\nМи вам обов'язково перетелефонуємо",
    faq: 'Питання та відповіді',

    projectTitle: 'Проєкт',
    about: 'Про проєкт',
    terms: 'Умови і правила',
    contacts: 'Контакти',
    tariffs: 'Тарифи',
    news: 'Новини',

    realEstateTitle: 'Нерухомість',
    flats: 'Квартири',
    rooms: 'Кімнати',
    houses: 'Будинки',
    offices: 'Офіси',
    areas: 'Земля',
    commercials: 'Комерційна',

    flats_by_city: 'Квартири по містах',
    houses_by_city: 'Будинки по містах',
    districts: 'Райони',
    streets: 'Вулиці',
    orients: 'Орієнтири',
    new_buildings: 'Новобудови',
    cottages: 'Котеджні містечка',

    specialistTitle: 'Рієлтори',
    rieltors: 'Рієлтори',
    firms: 'Агентства нерухомості',
    unions: 'Спільноти',
    top100: 'ТОП-100 АН України',
  },
  alerts: {
    deleted_avatar: {
      text: 'Добрий день!\n' +
        'Ми помітили у вашому профілі фото, яке не відповідає правилам завантаження аватарів ({reason}).\n' +
        '\n' +
        'На жаль, ми змушені були видалити його.\n' +
        'Будь ласка, {edit_link}, де чітко видно ваше обличчя, а також відсутні написи, сторонні предмети або люди.\n' +
        '\n' +
        'Так ваш профіль виглядатиме більш професійно та викличе більше довіри у клієнтів.'
    },
    force_avatar_alert: {
      title: 'Додайте ваше фото',
      text: 'Ваш профіль ще не має фото.  Додайте фото профілю, щоб потрапити до рейтингу рієлторів на сайті та підвищити довіру клієнтів.',
      text_alter: 'Для повноцінної публікації ваших оголошень обов\'язково додайте вашу справжню фотографію.',
      button: 'Завантажити фото',
    },
    new_status_soon_alert: {
      title: 'Залишилось {diff_html} до отримання статусу {newStatus_html} та збільшених бонусів до {newBonus_html}',
      title_diff_html: '{diff} грн',
      title_new_status_html: '{newStatus}',
      title_new_bonus_html: '+{newBonus}%',
      text: 'Вітаємо, {username}!\n' +
          '\n' +
          'До кінця тижня поповніть рахунок на {diff_html} і отримайте наступний рівень партнерського статусу {newStatus_html}.\n' +
          '\n' +
          'Вам будуть доступні збільшені з {oldBonus_html} до {newBonus_html} бонуси при поповненні рахунку.',
      text_diff_html: '{diff} грн',
      text_new_status_html: '{newStatus}',
      text_new_bonus_html: '{newBonus}%',
      text_old_bonus_html: '{oldBonus}%',
    },
    new_rieltor_bonus: {
      title: 'Вітаємо, {username}!',

    },
    new_rieltor_bonus_alert: {
      title: 'Вітаємо, {username}!',
      text: 'Дякуємо за реєстрацію на нашому порталі.\n' +
          '\n' +
          'Ви верифікували свій профіль, тому ми нарахували вам бонус {coins} для реклами ваших оголошень.\n\n' +
          'Ми прагнемо, щоб ваші перші публікації оголошень через кабінет Rieltor дали найкращий результат, тому автоматично підключаємо всі рекламні функції. Після поповнення кабінету ви зможете керувати ними самостійно.\n' +
          '\n' +
          'Бажаємо вдалих угод!  Дякуємо що ви з нами!\n',
      text_with_limit: 'Дякуємо за реєстрацію на нашому порталі.\n' +
        '\n' +
        'Ви верифікували свій профіль, тому ми нарахували вам бонус {coins} для реклами ваших оголошень, а також надали {limit} оголошень для безкоштовного розміщення.\n\n' +
        'Бажаємо вдалих угод!  Дякуємо що ви з нами!\n',
      old_new_text: 'У вас закінчився термін дії безкоштовного оголошення. Проте ми додатково нарахували вам бонус {coins} для реклами оголошень.\n' +
          '\n' +
          'Рекомендуємо використати бонусні кошти для додаткового просування на найвищі позиції сайту, щоб отримати більше звернень.\n' +
          '\n' +
          'Бажаємо вдалих угод!',
      old_top_users_text: '\nВам одноразово нараховано {coins}  на рахунок для публікації та реклами оголошень згідно програми підтримки від ЛУН 2025.\n' +
        '\n' +
        'Також зараз ви маєте можливість безкоштовно розміщувати до {limit}, решта — продовжують публікуватись вже на платній основі.\n' +
        '\n' +
        'Рекомендуємо використати бонусні кошти для підняття оголошень на найвищі позиції сайту, щоб отримати більше звернень від покупців.\n' +
        'Підняти оголошення: {link}\n' +
        '\n' +
        'Бажаємо вдалих угод!',
    },
    referrals_only_for_registration: 'Брати участь в програмі RIELTOR CONNECT 2024 може лише новий користувач',
    bankid_alert_2906:
      'Акція! Усі верифіковані через BankID рієлтори <b>отримають 500 грн</b>. для реклами оголошень!</br>' +
      'Встигніть верифікуватися <b>до 14 липня включно</b>, а вже 15 липня ми автоматично нарахуємо бонус на рахунок вашого профілю.</br>' +
      'Щоб пройти верифікацію, зайдіть в налаштування профілю <a href="https://my.rieltor.ua/profile/summary">https://my.rieltor.ua/profile/summary</a>',
    new_limit_0211020: {
      p1: 'Шановні користувачі!',
      p2: 'З метою значного підвищення ефективності порталу для вашого бізнесу, з 2 листопада 2020 року на сайті почнуть діяти нові правила. Тепер вартість оголошення становитиме 20 монет за добу.',
      p3: 'В понеділок мінімальна ставка спишеться з кожного платного оголошення.',
      p4: 'Якщо на вашому рахунку буде недостатньо коштів - оголошення перенесуться в Чорновики і ви зможете їх заново опублікувати в особистому кабінеті.',
      p5: 'Також нагадуємо, що ви можете отримувати бонус до 30% від суми поповнення вашого рахунку.',
      p6: 'Бажаємо вам ефективних продажів!',
    },
    email_not_confirmed:
      'Необхідно підтвердити e-mail для публікації оголошень. Лист для підтвердження був відправлений вам на {email}',
    no_phones:
      'Необхідно додати номер телефону для публікації оголошень. Це можна зробити на сторінці {link}',
    no_confirmed_phone:
      'Необхідно підтвердити номер телефону для публікації оголошень. Це можна зробити на сторінці {link}',
    user_edit: 'редагування профілю',
    insufficient_funds_alert:
      'Запас коштів на вашому рахунку {expires} {daysCount, plural, =0 {сьогодні} =1 {завтра} one {через # день} few {через # дні} other {через # днів}}. Не забудьте {link}, щоб зберегти позиції ваших оголошень на сайті',
    insufficient_funds_alert_expires: 'закінчується',
    insufficient_funds_alert_pay: 'поповнити баланс',
    pro_sub_renewal_alert_cancelled:
      'Rieltor PRO завершиться за {days, plural, one {# день} few {# дні} other {# днів}}.',
    pro_sub_renewal_alert_cancelled_description:
      '{link} підписку, щоб зберегти доступ до PRO-функцій.',
    pro_sub_renewal_alert:
      'Через {days, plural, one {# день} few {# дні} other {# днів}} відбудеться автоматичне оновлення вашої підписки на {featureName}.',
    pro_sub_renewal_alert_description:
      'Перевірте, будь ласка, чи достатньо коштів на рахунку та {link} — інакше доступ до PRO-функцій може бути призупинено.',
    multiple_rieltors_has_low_coins_reserve: 'Запас коштів на рахунку у {number} {number, plural, =1 {рієлтора} one {рієлтора} few {рієлторів} other {рієлторів}} закінчується. {link}',
    email_confirmed: 'Ваш email успішно підтверджений',
    bankid: {
      already_verified_another_user:
        'Ваш BankID вже був верифікований в іншому акаунті',
      bankid_already_verified: 'Ви вже верифіковані',
      bankid_general_error: '',
      bankid_error_redirect: 'Помилка редиректу, спробуйте ще раз',
      bankid_verified_success: 'Ви були успішно верифіковані',
      bankid_verified_new_rieltor_success: 'Ви були успішно верифіковані\nВам нараховано {coins} монет на рахунок від Rieltor.ua для реклами ваших оголошень',
      bankid_verified_new_rieltor_success_no_bonus: 'Ви успішно верифікували профіль',
      bankid_verified_registration_finish: 'Завершити реєстрацію',
      bankid_unknown_error:
        "Невідома помилка, зверніться в службу підтримки 097 154 85 32'",
      bankid_already_verified_another_user_limit:
        'Ліміт можливих верифікацій вичерпано. При наступній спробі верифікації всі ваші аккаунти будуть заблоковані модераторами',
      restore_user: 'Відновити профіль',
      user_deleted: 'Профіль користувача {username} видалено, але ви можете відновити його',
      verification_not_match: 'Дані верифікації не відповідають даним на сайті',
    },
    payment: {
      successful: 'Ваш рахунок поповнено на {price}',
      successful_prro: 'Ваш рахунок поповнено на {price}. Фіскальний чек відправлено на електронну пошту, вказану в профілі, або у viber/sms',
      processing: 'Платіж був успішно створений і знаходиться в обробці',
      wait_for_cash: 'Очікується оплата готівкою в ТСО',
      wait: 'Очікується оплата обраним вами способом',
      failed: 'Сталася помилка під час транзакції',
      payment_gift_successful: 'Ваш подарунок вже отримали! Рахунок рієлтора {username} поповнено на {price}.',
    },

    non_verified_rieltor: {
      text: 'Увага! Ваші оголошення не відображаються в пошуку на порталі Rieltor, а також на ЛУН, Flatfy та Bird через відсутність верифікації вашого профілю. {link}',
      link: 'Верифікуйте свій профіль зараз.',
    },
    avatar: {
      no_avatar: {
        agency_text:
          "Рекомендуємо {edit_link}  у профіль, щоб ваше АН з'явилось у рейтингу та списку рекомендованих.",
        realtor_text:
          "{edit_link} у профіль, щоб з'явитись у рейтингу рієлторів та в списку рекомендованих",
        realtor_text_danger: "Для повноцінної публікації ваших оголошень обов'язково {edit_link} вашу справжню фотографію.",
        add_agency_logo: 'додати логотип агентства',
        add_personal_photo: 'Додайте особисте фото',
      },
      not_a_person: {
        text: 'Необхідно {edit_link} у профіль. Поточне фото не відповідає правилам сайту і буде видалене через 3 дні.',
        upload_personal_photo: 'завантажте ваше особисте і реальне фото',
      },
    },
  },
  profile: {
    settings: 'Налаштування',
    phone_has_viber: 'Підключений до Viber',
    phone_has_telegram: 'Підключений до Telegram',

    user_agency: {
      title: "Прив'язати агентство",
      request: 'Відправити запит',
      delete: 'Видалити',
      cancel: 'Скасувати',
      placeholder: 'Назва агентства',
    },
  },
  profile_stats: {
    balance_title: 'Мій баланс',
    balance_title_agency: 'Баланс агентства',
    firm_balance_title: 'Баланс рієлторів',
    views_title: 'Перегляди і покази контактів',
    month_stats: 'Всього за останній місяць',
    stats_title: 'Статистика оголошень',
    daily_consumption_title: 'Витрата',
    daily_consumption_title_agency: 'Витрати агентства',
    firm_daily_consumption_title: 'Витрати рієлторів на добу',
    per_day: ' на добу',
    enough_for_days_title: 'Вистачить',
    enough_for_days: '{count, plural, one {# день} few {# дні} other {# днів}}',
    pay_button: 'Поповнити рахунок',
    operations_title: 'Мої фінансові операції',
    no_operations: 'Ще не було поповнень',
    views_amount: 'Переглядів',
    uah_amount: 'Витрачено монет',
    click_amount: 'Показів контактів',
    message_amount: 'Повідомлень',
    favorites_amount: 'Додавань у обране',
    period_month: 'Місяць',
    period_quarter: '3 Місяці',
    period_year: 'Рік',
    period_2year: '2 роки',
    period_3year: '3 роки',
    agenda_views: 'Переглядів оголошень',
    agenda_contacts: 'Показів контактів',
    agenda_viber: 'Повідомлень у Viber / Telegram',
    agenda_favorites: 'Додавань у обране',
    deals_title: 'Витрати та угоди',
    offers_pickup_title1: 'Оголошення',
    offers_pickup_title2: 'Рекламні функції',
    deals_debits_amount: 'витрати в грн',
    deals_rent_count: 'кількість угод в розділі оренди',
    deals_sale_count: 'кількість угод в розділі продаж',
    deals_agenda_debits: ' — витрати',
    deals_agenda_sales: ' — угод у продажах',
    deals_agenda_rents: ' — угод в оренді',
    deals_empty_title1: 'У вас відсутні угоди',
    deals_empty_title2: 'Тут будуть відображатися оголошення, які ви перенесли в угоди',
    deals_faq_link: 'Як перенести в угоди?',

    columns: {
      date: 'Дата',
      sum: 'Сума',
      operation_name: 'Операція',
    },
    statistics: {
      total_offers: 'Всього активних оголошень',
      picked_up_count: '"Піднято" оголошень',
      premium_count: '"Преміум" оголошень',
      auto_refresh_count: 'З автооновленням',
      pickups_base: ' З мінімальною ставкою',
      pickups_over: ' З підвищенною ставкою',
      pickups_free: 'Безкоштовні',
    },
    renta_stats: {
      views: 'Переглядів',
      click_contacts: 'Натискань на "показати контакти"',
      send_messages: 'Натискань на "відправити повідомлення"',
    },
    views: {
      today: 'Сьогодні',
      yesterday: 'Вчора',
      week: 'За тиждень',
      all_time: 'Всього',
    },
  },
  profile_agents: {
    confirmed_title: 'Підтвердженні агенти · {count, number}',
    unconfirmed_title: 'Очікують підтвердження · {count, number}',
    stats: `{offers, plural,
      one {# оголошення}
      few {# оголошення}
      other {# оголошень}
    } · {views, plural,
      one {# перегляд}
      few {# перегляди}
      other {# переглядів}
    } · {comments, plural,
      one {# відгук}
      few {# відгуки}
      other {# відгуків}
    }`,
    rating: 'Рейтинг: {value, number}',
    actions: {
      confirm: 'Підтвердити',
      delete: 'Видалити',
    },
    no_results: 'Не знайдено',
  },
  rieltor_manifest_screen: {
    text1_link: 'Маніфест “Я - RIELTOR”',
    text_generic: 'Бажаєте підтримати Маніфест “Я - RIELTOR”?',
    text2_generic: 'Оберіть одну з частин Маніфесту та отримайте фото для публікації в Facebook та Instagram.',
    text3_generic: '',
    text_rieltor_day: 'Вітаємо з Днем Рієлтора!',
    text2_rieltor_day: 'Команда Rieltor.ua щиро дякує вам за співпрацю, відданість своїй справі та незмінний професіоналізм.',
    text3_rieltor_day: 'День Рієлтора - не лише привід для привітань, але й нагода згадати про професійні цінності, які задекларовані в Маніфесті «Я-RIELTOR».\n' +
      'Оберіть одну з частин Маніфесту та отримайте фото-листівку для привітання колег та клієнтів в Facebook та Instagram.',
    i_am_rieltor: 'Я RIELTOR',
    download_button: 'Завантажити',
    share_button: 'Поділитись',
    copy: 'Посилання скопійоване',
    mobile_variant_title: 'Оберіть цитату з маніфесту',
    expand_items_button: 'Обрати іншу цитату',
    goto_section_button: 'Перейти в розділ',
  },
  profile_new_agents_screen: {
    chips: {
      active: 'Активні',
      inactive: 'Неактивні',
      requested: 'Очікують підтвердження',
    },
    rieltors: 'Рієлтори',
    confirmed_title: 'Підтвердженні агенти',
    unconfirmed_title: 'Очікують підтвердження',
    agents_count: '({count})',
    table: {
      title: 'Рієлтор',
      office: 'Філія',
      city: 'Місто',
      tel: 'Телефон',
      verificated: 'Вериф',
      offers: 'Оголошень',
      views: 'Переглядів',
      view_contacts: 'Показів \nконтактів',
      viber: 'Повідомлень\nу Viber',
      coasts: 'Витрати \n(на день)',
      user_expenses: 'Витрати \n(на 30 днів)',
      costs_last: 'Витрати \n(остання\nактивність)',
      balans: 'Баланс',
      balans_days_left: 'Закінчиться\nчерез',
      delete: 'Відв’язати \nвід агентства',
      confirm: 'Підтвердити',
      move: 'Нарахувати',
      change_office: 'Вказати філію',
    },
    delete_dialog: {
      title: 'Ви намагаєтесь відв’язати рієлтора від Агентства',
      text: 'При відв’язанні його акаунту, всі оголошення агента зникнуть зі сторінки агентства',
      untie: 'Відв’язати',
    },
    give_coins_dialog: {
      title: 'Нарахування монет',
      text: 'Баланс агентства',
      count_done: 'Нарахувати',
      give_success: 'Монети успішно нараховані',
    },

    change_agent_office_dialog: {
      title: 'Вказати філію',
      done: 'Вказати',
      text: 'Виберіть філію, до якої потрібно прикріпити рієлтора',
      office: 'Філія',
      give_success: 'Рієлтор успішно прикріплений до філії',
    },
  },
  pagination: {
    on_page: 'На сторінці',
    description: '{from} - {to} з {count}',
  },
  profile_edit: {
    add_viber: "Прив'язати Viber",
    add_telegram: "Прив'язати Telegram",
    volunteer: {
      title: 'Зараз працюю 💪',
    },
    allow_share: {
      title: 'Заборонити колегам-агентам відправляти пропозиції по моїх об’єктах своїм клієнтам (не поширюється на рієлторів із пакетом PRO).',
    },
    display_sold_offers: {
      title: 'Не показувати Портфоліо реалізованих об’єктів на своїй сторінці'
    },
    disable_partner_messaging: {
      title: 'Не отримувати повідомлення про нові оголошення у закритій базі та про закриті угоди партнерів.'
    },
    an_offices: {
      add_btn: 'Додати філію',
      delete_btn: 'Видалити філію',
      office_photo: 'Фото офісу',
      office_name: 'Назва офісу',
      phones_empty: 'Потрібно ввести телефон філії',
      new_phone: {
        duplicate_error: 'Такий телефон уже є',
      },
    },
    an_styles: {
      bg_color: 'Колір фону',
      text_color: 'Колір тексту',
      bg_img: 'Фонове зображення',
    },
    steps: {
      allow_share: 'Робота з колегами',
      an_styles: 'Стилізація сторінки',
      an_offices: 'Філії агентства',
      ui_price_currency: {
        title: 'Відображення ціни',
        [UIPriceCurrency.Coins]: '{coins} (монети)',
        [UIPriceCurrency.UAH]: '₴ (гривні)',
      },
      phones: {
        title: 'Змінити (додати) номер телефону',
        text1:
          'Щоб <b>додати</b> Viber - додайте новий номер, на якому є додаток і введіть код, який ми надіслали вам у Viber',
        text2:
          'Щоб <b>підтвердити</b> Viber на наявному номері - просто натисніть відповідну кнопку і введіть код, який ми надіслали вам у Viber',
        text3:
          'Щоб <b>підтвердити</b> Telegram на наявному номері - просто натисніть відповідну кнопку',
      },
      info: 'Редагувати профіль',
      password: 'Змінити пароль',
      email: 'Змінити Email',
      delete_profile: '5. Видалити профіль',
      social: 'Редагувати соціальні мережі',
    },
    delete_profile: {
      button: 'Видалити профіль',
      title: 'Видалити профіль?',
      description:
        'Ви намагаєтеся <b>ВИДАЛИТИ ПРОФІЛЬ</b>! Ви впевнені, що хочете це зробити?',
      yes: 'Видалити',
      cancel: 'Скасувати',
    },
    phone: {
      main_phone: 'Головний телефон',
      simple_phone: 'Телефон',
      new_phone: 'Новий телефон',
      add_phone: 'Додати',
      confirm: 'Підтвердити',
      did_not_receive_code: 'Не прийшов? {button}',
      resend: 'Надіслати повторно',
      set_main_phone: 'Зробити головним',
      delete_phone: 'Видалити телефон',
      confirmed: 'Підтверджений телефон',
      unconfirmed: 'Непідтверджений телефон',
      has_viber: 'Підключений до Viber',
      has_telegram: 'Підключений до Telegram',
      attention: 'Увага',
      static_phone_description:
        "{attention}: Для підтвердження номера телефону зв'яжіться з нашою службою підтримки {phone} або {viber}",
      contact_by_phone: 'за телефоном',
      contact_by_viber: 'у Viber',
      delete_telegram_confirmation: {
        description: 'Ви намагаєтеся <b>видалити номер телефону</b> з підтвердженим Telegram. ' +
            'Підключена функція Bird-top у оголошеннях вимкнеться',
        title: 'Видалити номер телефону?',
        confirm: 'Видалити',
        cancel: 'Скасувати',
      },
    },
    info: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      youtube: 'Youtube',
      tiktok: 'Tik Tok',
      website: 'Сайт',
      owner: {
        name: "Ім'я",
        email: 'Email',
        city: 'Місто',
        image: 'Фото',
        password: 'Пароль',
        inn: 'РНОКПП (ідентифікаційний податковий номер)',
      },
      realtor: {
        name: 'ПІБ',
        email: 'Email',
        city: 'Місто',
        image: 'Фото',
        site: 'Сайт',
        started_at: 'Працюю рієлтором з',
        about: 'Про себе',
        speak_english: 'Speak English',
        specialization: 'Спеціалізація',
        password: 'Пароль',
      },
      agency: {
        name: 'Назва агентства',
        email: 'Email',
        city: 'Місто',
        street: 'Вулиця',
        house: 'Будинок',
        address: 'Уточнююча адреса',
        site: 'Сайт',
        started_at: 'Працюємо на ринку з',
        about: 'Опис',
        specialization: 'Спеціалізація',
        image: 'Логотип агентства',
        password: 'Пароль',
      },
      success: 'Інформація успішно збережена',
    },
    email: {
      current: 'Поточний e-mail',
      new: 'Новий e-mail',
      success:
        'Новий e-mail успішно збережений',
    },
    password: {
      old: 'Старий пароль',
      new: 'Новий пароль',
      success: 'Новий пароль успішно збережений',
    },
    save: 'Зберегти',
  },
  user_props: {
    owner: {
      city: 'Місто',
      email: 'Email',
      image: 'Фото',
      name: "Ім'я",
      password: 'Пароль',
      phone: 'Телефон',
    },
    realtor: {
      about: 'Про себе',
      agency: 'Агентство',
      city: 'Місто',
      email: 'Email',
      experience: 'Досвід роботи',
      image: 'Фото',
      name: 'ПІБ',
      password: 'Пароль',
      phone: 'Телефон',
      site: 'Сайт',
      speak_english: 'Speak English',
      specialization: 'Спеціалізація',
      bankid_verificate: 'Верифікуватись',
      diia_verificate: 'Верифікуватись',
      bankid_verificated: 'Верифіковано',
      diia_verificated: 'Верифіковано',
      need_refresh: 'Оновити верифікацію:',
    },
    agency: {
      about: 'Опис',
      address: 'Адреса',
      city: 'Місто',
      email: 'Email',
      experience: 'Досвід на ринку',
      house: 'Будинок',
      image: 'Логотип агентства',
      name: 'Назва агентства',
      password: 'Пароль',
      phone: 'Телефон',
      site: 'Сайт',
      specialization: 'Спеціалізація',
      street: 'Вулиця',
      status: 'Статус',
    },
    experience_value: `{
      fullYears, plural,
        =0 {}
        one {# рік}
        few {# роки}
        other {# років}
      } {
        fullMonths, plural,
        =0 {}
        one {# місяць}
        few {# місяці}
        other {# місяців}
      }`,
    rating: 'Рейтинг: {points, number}',
    level_status: {
      copy: 'Скопіювати код' ,
      remark: 'Поділіться партнерським статусом на сайті вашого Агентства.\n' +
          'Для цього достатньо скопіювати код та вставити у футер вашого сайту.\n' +
          'Коли ваш статус підвищиться, картинка на сайті оновиться автоматично.'
    }
  },
  agents_suggestions: {
    title: 'Оголошення опубліковане!',
    description: `Ви також можете звернутися до рієлторів, які спеціалізуються на {
        operType, select,
          ${OperType.Sale} {продажі} 
          ${OperType.Rent} {оренді} 
          ${OperType.DailyRent} {подобовій оренді}
      } {
        itemType, select,
          ${ItemType.Flats} {квартир}
          ${ItemType.Houses} {будинків}
          ${ItemType.Rooms} {кімнат}
          ${ItemType.Commercial} {комерційної нерухомості}
          ${ItemType.Parking} {гаражів і паркомісць}
          ${ItemType.Land} {землі}
      } в {cityNamePrepositional}:`,
    show_phone: 'Показати телефон',
    send_viber: 'Написати в Viber',
    back_to_offers: 'Назад до кабінету',
  },
  bottom_tabs: {
    dashboard: 'Головна',
    profile: 'Профіль',
    agents: 'Рієлтори',
    stats: 'Статистика',
    payment: 'Поповнити',
    offers: 'Оголошення',
    market: 'Ринок',
  },
  side_navigation: {
    my_site: 'Мій сайт',
    settings: 'Налаштування',
    logout: 'Вийти',
    language: 'Мова інтерфейсу',
    support: {
      title: 'Служба підтримки',
      phone: 'Телефон',
      viber: 'Viber',
      faq: 'Питання та відповіді',
      schedule: 'Щоденно з 9:00 до 18:00',
      support_holidays:
        "Зверніть увагу!\n23.08 - 24.08 команда Rieltor.ua не працює.\nМи вам обов'язково перетелефонуємо",
    },
    logout_confirmation: {
      title: 'Вихід',
      text: 'Ви впевнені, що хочете вийти з кабінету?',
      logout: 'Вийти',
      cancel: 'Скасувати',
    },
  },
  after_register: {
    description:
      'Радимо підтвердити свою особу за допомогою Bank ID і ми зможемо радити вас користувачам',
    button2: 'пропустити',
  },
  dashboard: {
    add_viber: 'Додайте Viber',
    viber_added: 'Viber підключено',
    add_telegram: 'Додайте Telegram',
    telegram_added: 'Telegram підключено',
    my_profile: 'Мій профіль',
    edit_profile: 'Налаштування',
    add_photo: '+Додайте фото',
    finance_stat: 'Фінансова статистика',
    my_balance: 'Мій баланс',
    daily_consumption_title: 'Витрата',
    daily_consumption_title_long: 'Витрати на добу',
    per_day: ' на добу',
    enough_for_days_title: 'Вистачить',
    asnu_added: 'Сертифікат АФНУ',
    add_asnu_sfnu: 'Додайте сертифікат',
    asnu_sfnu_added: 'Додайте сертифікат',
    add_asnu: 'Додайте сертифікат',
    sfnu_added: 'Сертифікат СФНУ',
    add_sfnu: 'Додайте сертифікат',
    verification_added: 'Верифікований профіль',
    add_verification: 'Верифікуйтесь',
    add_verification_description: 'Верифікуйте свій профіль, щоб продовжувати публікувати оголошення на порталі.',
    add_verification_description_activate: 'Верифікуйте свій профіль, щоб опублікувати оголошення на порталі',
    add_exp: 'Вкажіть досвід',
    add_rating: 'В рейтингу відсутні',
    exp_added: '',
    on_site_added: '',
    add_on_site: '',
    an_offices_added: 'Філій',
    add_an_offices: 'Додайте філії',
    an_rieltors_added: 'Рієлторів',
    add_an_rieltors: 'Рієлторів',
    add_subscription: 'Підключити\nRieltor PRO',
    subscription_added: 'Професійний\nакаунт',
    add_my_website: 'Мій сайт',
    my_website_added: 'Мій сайт',
    certificates: {
      empty: 'Сертифікат',
    },
    bankid: {
      verify: 'Верифікуйтесь',
      verificated: 'Верифікований профіль',
    },
    my_offers: {
      title: 'Мої оголошення',
      title_agency: 'Оголошення рієлторів',
      show_offers: 'До моїх оголошень',
    },
    my_deals: {
      title: 'Мої угоди',
      avg_title: 'Середній термін експозиції',
      empty_title1: 'У вас відсутні угоди',
      empty_title2:
        "Тут будуть відображатися об'єкти, які ви відмітили як продані/здані",
      deals_faq_link: 'Як відмітити угоди?',
    },
    statistics: {
      total_active_offers: 'Активних оголошень',
      total_offers: 'Всього оголошень',
      picked_up_count: '"Піднято" оголошень',
      premium_count: 'Велике фото + Мітка',
      auto_refresh_count: 'Автооновлення',
      bird_top: 'ЛУН+Bird ТОП',
      bird_select: 'Bird SELECT',
      lun_top: 'ЛУН ТОП',
      view_details: 'Детальна статистика',
    },
    grafik: {
      title: 'Перегляди и покази контактів',
    },
  },

  referrals: {
    second_text :'Правила програми:',
    second_li_1: 'програма діє лише для осіб, які займаються рієлторською діяльністю',
    second_li_2: 'повторна верифікація профілю за реферальним посиланням неможлива',
    second_li_3: 'нараховані кошти неможливо перевести на інший акаунт, повернути або вивести на картку',
    verification_link: 'Верифікуватися',
    more_link: 'Детальніше',
    alert_title: '<b>RIELTOR CONNECT 2024</b><br> Запросіть колег на <u>Rieltor.ua</u> - отримуйте 10% від їх поповнень протягом всього 2024 року.',
    alert_text_1: 'Надішліть унікальне посилання колезі або розмістіть його у соцмережах.<br>Ви отримаєте',
    alert_text_2: 'на рахунок за кожного нового рієлтора, який зареєструється за вашим посиланням та верифікує свій профіль за допомогою BankID. Усі нові запрошені рієлтори також отримають по',
    alert_text_3: 'після верифікації профілю за допомогою BankID.',
    alert_subtitle:
      'Більше запрошених рієлторів - більше бонусів на вашому рахунку',
    stat_total_registered: 'Всього зареєструвались',
    stat_total_verified: 'Верифікувались',
    stat_total_points: 'Колеги поповнили, грн',
    stat_total_refs_points: 'Колеги отримали, грн',
    page_title: '“RIELTOR CONNECT 2024“. Нова програма підтримки рієлторів від ЛУН',
    referrals_title: 'Ви запросили',
    status_false: 'Не верифіковано',
    status_true: 'Верифіковано',
    assign_success:
      'Послуга активована. Для отримання бонусу вам необхідно верифікуватись',
    share_title: 'Надіслати посилання в соцмережі:',
    copy_referral: 'Посилання скопійоване',
    bankid_alert: 'Доступно лише для верифікованих спеціалістів',
    rating_text_1: 'Ви на',
    rating_text_2: ' в рейтингу учасників програми  «RIELTOR CONNECT 2024»',
    rating_text_no_bankid: 'Ви поки не у рейтингу “RIELTOR CONNECT 2024“, верифікуйтесь, щоб стати учасником програми',
    rating_position: 'місці',
    register_title1: 'запрошує вас зареєструватись на сайті',
    register_title2_1: 'Після реєстрації та верифікації за програмою <b>“RIELTOR CONNECT 2024“</b> ви отримаєте',
    register_title2_2: 'на рахунок, які зможете використати для реклами ваших оголошень.',
    no_rating_text: 'Рейтинг учасників програми  «RIELTOR CONNECT 2024»',
    register_benefits_title_mobile: 'RIELTOR.UA — це:',
    register_benefits_title: '— це',
    register_benefits_hide: 'Cховати',
    register_benefit_1: 'понад 2 млн відвідувачів на місяць',
    register_benefit_2: 'поденна оплата за оголошення — ніяких переплат',
    register_benefit_3: 'найшвидша публікація на Flatfy від ЛУН',
    register_benefit_4: 'участь у рейтингу найкращих рієлторів України',
    register_benefit_5: 'заявки від клієнтів прямо у Вайбер',
    register_benefit_6: 'зручне розміщення оголошення та прозору статистику',
    rating_link: 'Дивитись',
    copy: 'Копіювати',
    new_step_title: '3 січня 2024 року ми запускаємо нову програму підтримки рієлторської спільноти:',
    new_step_1: 'запросіть колег зареєструватись на Rieltor.ua за вашим персональним посиланням до 31 січня 2024 року',
    new_step_2: 'після верифікації профілю вони отримають {coins} на рахунок для реклами своїх оголошень',
    new_step_3: 'ви будете отримувати {percent} на свій рахунок від суми поповнень всіх верифікованих колег протягом всього 2024 року',

    new_info_text_1: 'Оскільки кожен запрошений рієлтор після верифікації зможе мати лише один профіль, тому 10% від поповнень буде отримувати лише той рієлтор, що його запросив.',
    new_info_text_2: 'Запрошення дійсні лише з 1 по 31 січня, тільки для верифікованих рієлторів.\nПоспішіть запросити ваших колег за вашим посиланням, щоб отримати 10% бонус від їх поповнень.',
    'steps_title': 'Кому допомагатиме ЛУН? Це обираєте саме ви!',
    'info_text_1': 'Ми в ЛУН хочемо допомогти рієлторам повернутись до роботи, а ринку нерухомості відновитись. Тому у липні на',
    'info_text_2': 'ми запускаємо нову програму підтримки <b>“RIELTOR CONNECT 2024“</b>: ви можете допомогти колегам отримати по',
    'info_text_no_verif_2': 'ми запускаємо нову програму підтримки <b>“RIELTOR CONNECT 2024“</b>: отримайте',
    'info_text_3': 'на рахунок, а також отримати по',
    'info_text_no_verif_3': 'на рахунок, верифікувавши свій обліковий запис через BankID. Це займає 2 хвилини. Після верифікації ви зможете допомогти своїм колегам разом з нами.',
    'info_text_4': 'на свій рахунок за кожного, кого запросите до наших лав.',
    'input_description': 'Скопіюйте ваше персональне посилання нижче, поділіться ним із колегами у соцмережах та особистих повідомленнях:',
    'details': 'Деталі',
    text_918_1: 'У разі фіксації порушень умов програми нарахування можуть бути скасовані, а профіль на сайті заблокований.',
    program_not_active: 'Програма підтримки рієлторів завершена',
  },
  tariffs: {
    title: 'Оберіть {link} для реклами вашого оголошення',
    day_cost: '{amount} грн/доба за 1 оголошення',
    total_cost: '{amount}',
    total_cost_month: 'грн./міс',
    base: 'Публікація',
    auto: 'Публікація + автооновлення',
    premium: 'Преміум публікація',
    payment: 'Оплатити',
    publish: 'Опублікувати',
    wait_for_payment:
      'Після успішної оплати ваше оголошення буде опубліковано автоматично',
    submit: 'Готово',
  },
  stripe_payment: {
    button: 'Оплатити {amount} €',
  },
  liqpay_payment: {
    error_payment: 'Повторити платіж',
  },
  olx_migration: {
    page_title: 'З OLX на RIELTOR',
    success: 'Посилання успішно додано',

    left_text_1: 'Публікуйте усі ваші активні оголошення з OLX {left_text_1_1}',
    left_text_1_1: 'безкоштовно на RIELTOR.',

    left_text_2:
      'Додайте посилання на ваш профіль OLX і протягом доби всі оголошення уже будуть на RIELTOR - {left_text_2_1} 💜',
    left_text_2_1: 'абсолютно безкоштовно',

    right_text_1:
      'Також ми нарахуємо додатково {right_text_1_1}, якщо ви верифіковані на сайті.',
    right_text_1_1: '{coins} 200 монет за кожне перенесене оголошення',
    right_text_2:
      'Ці монети можна використовувати для додаткової реклами та підняття.',
    placeholder: 'Посилання',

    button_more: 'Детальніше',
    button1: 'Перейти',
    header1: 'З OLX на RIELTOR — в один клік 🚀',
    dialog: {
      title: 'Дякуємо',
      text: 'Ваші оголошення уже обробляються',
    },
  },
  olx_migration_screen: {
    header: 'З OLX на RIELTOR {br} — в один клік 🚀',

    text_1: 'Публікуйте усі ваші оголошення з {text_1_1}',
    text_1_1: 'OLX безкоштовно на RIELTOR',

    text_2: '💜 Короткий рецепт переїзду',
    step_1: 'Додайте посилання на ваш профіль OLX',
    step_2:
      'Трішки почекайте (ми тестуємо все, тому переїзд займе не більше доби)',
    step_3: 'Насолоджуйтеся перевагами RIELTOR безкоштовно.',

    text_3:
      'А ще ми любимо бонуси та надаємо {text_3_1}, якщо ви верифіковані через BankID на сайті (про верифікацію за допомогою BankID — {link})',
    text_3_1: '{coins} 200 монет за кожне перенесене оголошення',

    text_4:
      'Використовуйте монети щоб вигідно виділити свої оголошення серед інших та напишіть нам якщо у вас є додаткові запитання.',
  },
  partners_screen: {
    chips: {
      partners: 'Партнери',
      deals: 'Угоди партнерів',
      offers: "Закрита база об'єктів партнерів",
    },
    no_bankid: {
      title: 'Розділ “Мої партнери” доступний для верифікованих користувачів, щоб',
      verify: 'Верифікуйтесь',
    },
    confirmed_title: 'Підтверджені партнери',
    unconfirmed_title_me: 'Запити до мене',
    unconfirmed_title_my: 'Запити від мене',
    partners_count: '{count, number}',
    add_partners_button: 'Додати партнерів',
    no_results: {
      title: 'У вас ще немає партнерів',
      list_title: 'Створіть свою мережу партнерів, щоб мати можливість:',
      list_item_1: 'обмінюватись інформацією про угоди',
      list_item_2: 'працювати разом над обʼєктами',
    },
    no_offers: {
      title: 'У ваших партнерів ще немає об\'єктів в закритій базі',
      list_title: 'Ви та ваші партнери можете створити оголошення та перенести його в закриту базу:',
      list_item_1: 'Це безкоштовно',
      list_item_2: 'Оголошення не буде відображатись на порталі та особистій сторінці',
      list_item_3: 'Доступ до оголошення по посиланню - можна відправити клієнтам чи колегам',
      list_item_4: 'Оголошення буде автоматично відображатись в особистому кабінеті на цій вкладці розділу "Мої партнери"',
    },
    no_partner_offers: {
      title: 'У вас ще немає оголошень',
      list_title: 'Створіть оголошення та перенесіть його у закриту базу:',
      list_item_1: 'Це безкоштовно',
      list_item_2: 'Оголошення не буде відображатись на порталі та особистій сторінці',
      list_item_3: 'Доступ до оголошення по посиланню - можна відправити клієнтам чи колегам',
      list_item_4: 'Оголошення буде автоматично відображатись вашим партнерам в їхньому особистому кабінеті у розділі "Мої партнери" на вкладці "Закрита база об\'єктів"',
    },
    add_partner_dialog: {
      title: 'Додати партнера',
      info: {
        an: 'АН:',
        offers: 'Оголошень:',
        city: 'Місто:'
      },
      add: 'Додати',
      invite: 'Запросити',
      not_found: 'Не знайдено',
      not_found_phone: 'Користувача з номером телефону \n{phone}\n не знайдено',
      not_found_invite: 'Запросіть зареєструватись на RIELTOR.UA',
      approve_request: 'Запит на додавання до партнерів надіслано',
      invite_text: 'Запрошую на сайт RIELTOR.UA https://my.rieltor.ua/registration'
    },
    delete_dialog: {
      titleAccepted: 'Ви впевнені, що хочете видалити рієлтора зі списку партнерів',
      titleDeclined: 'Ви впевнені, що хочете відхилити запит на партнерство',
      titleCancel: 'Ви впевнені, що хочете скасувати запит на партнерство',
      text: 'При відв\'язці його облікового запису всі оголошення агента зникнуть зі сторінки агентства',
      buttons: {
        accepted: {
          yes: 'Видалити',
          no: 'Не видаляти',
        },
        declined: {
          yes: 'Відхилити',
          no: 'Не відхиляти',
        },
        cancel: {
          yes: 'Скасувати',
          no: 'Не скасовувати',
        },
      }
    },
    table: {
      title: 'Рієлтор',
      city: 'Місто',
      tel: 'Телефон',
      verificated: 'Вериф',
      offers: 'Оголошень',
      views: 'Переглядів',
      view_contacts: 'Показів \nконтактів',
      viber: 'Повідомлень\nу Viber',
      coasts: 'Витрати \n(на день)',
      balans: 'Баланс',
      confirm: 'Підтвердити',
      move: 'Нарахувати',
      cancel_request: 'Скасувати запит',
      delete: 'Видалити',
      deals_count: 'Кількість\nугод',
      partners_offers_count: `Кількість оголошень\nдля партнерів`,
      private_offers_count: `Кількість об'єктів\nзакритої бази`
    },
  },
  unions_screen: {
    no_bankid: {
      title: 'Розділ “Спільноти” доступний для верифікованих користувачів, щоб',
      verify: 'Верифікуйтесь',
    },
  },
  diia: {
    title: 'Як верифікуватись через Дію?',
    fail_title: 'Спроба верифікації невдала',
    text: 'Зчитайте QR-код сканером у застосунку Дія й підтвердьте авторизацію Дія.Підписом',
    left_time: 'QR-код буде дійсний ще\u00A0',
    update_qr: 'Оновити QR-код',
    already_verified_another_user: 'Ваші дані вже були верифіковані в іншому акаунті',
    verification_not_match: 'Дані верифікації не відповідають даним на сайті',
    qr_outdated: 'QR-код застарів',
    restore_user: 'Відновити профіль',
    user_deleted: 'Профіль користувача {username} видалено, але ви можете відновити його',
    user_deleted_modal: 'Дані для верифікації вже існують у видаленому профілі {username}, ви можете відновити його',
  },
  common_dialog: {
    actions: {
      yes: 'Так',
      no: 'Ні',
    },
  },
  gift_address: {
    description: 'Іноді ми надсилаємо подарунки нашим користувачам. Вкажіть адресу найближчої Нової Пошти, щоб вам було зручно отримувати від нас доставку.',
    form: {
      autocomplete: {
        city: 'Місто',
        novaposhta: 'Нова пошта',
      },
      phone: 'Номер телефону',
    },
    title: 'Деталі доставки',
    notification: {
      success: 'Дані успішно збережено',
    }
  },
  unions: {
    modes: {
      asnu_members: 'Спільнота АФНУ',
      asnu_deals: 'Угоди членів спільноти АФНУ',
      asnu_offers: 'Закрита база членів АФНУ',
      sfnu_members: 'Спільнота СФНУ',
      sfnu_deals: 'Угоди членів спільноти СФНУ',
      sfnu_offers: 'Закрита база членів СФНУ',
    }
  },
  pro_sub:{
    cancel: {
      yes: 'Скасувати',
      no: 'Залишити PRO'
    }
  },
  table: {
    filters: {
      id: 'Id',
      itemType: 'Тип',
      operType: 'Розділ',
      rooms: 'Кімн',
      floor: 'Пов',
      city: 'Місто',
      district: 'Район',
      address: 'Адреса',
      area: 'Площа',
      price: 'Ціна',
      userPrice: 'Ціна угоди',
      areaPrice: 'Ціна угоди, м²',
      auction: 'Торг',
      totalPickupSum: 'Рекламні витрати',
      itemCreatedAt: 'Створено', // Renta item created
      dealDelete: 'Вида\u00adлити',
      dealCreatedAt: 'Перенесено\nв угоди', // History item created
      diffDays: 'Термін\nекспозиції',
      rieltorName: 'Рієлтор',
      payCommission: 'Діл\nКоміс',
      exclusive: 'Екс',
      createdAt: 'Створено',
      createdAtShort: 'Створ',
      viewsToday: 'Сьогодні',
      viewsTodayShort: 'Сьог.',
      updatedAt: 'Онов',
      report: 'Звіт',
      edit: 'Ред.',
      position: 'Поз.\nмісто',
      positionRegion: 'Поз.\nобл',
      coins: 'Монет',
      services: 'Публікація',
      pickup_or_activate: 'Підняти/\nОпублікувати',
      activate: 'Опублікувати',
      share: 'Поділитися',
      notes: 'Нотатки',
      draftCreatedAt: 'Перенесено\nв чернетки',
      deletedCreatedAt: 'Дата\nвидалення',
      moderateCreatedAt: 'Відправлено\nна модерацію',
      moderateStatus: 'Статус',
      banReason: 'Причина бану',
      banDate: 'Забанено',
      banEdit: 'Виправити\nоголошення',
      geo_filter: 'Робоча область',
    },
    sort: {
      dealsCreatedAt: 'По даті угоди',
      offersCreatedAt: 'По даті створення',
      itemCreatedAt: 'По даті оголошення',
      price: 'По ціні',
      diffDays: 'По експозиції',
      rate: 'Монети',
      offersUpdatedAt: 'По даті'
    },
  },
  pro_alert: {
    title: 'Доступно з підпискою Rieltor PRO',
    text: '{link} підписку Rieltor PRO та отримайте доступ до всіх функцій',
    link: 'Придбайте'
  }
};
